import "core-js/modules/es.array.reduce";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Treeshaking safe.
var MediaType = function MediaType() {};

MediaType.NONE = 0;
MediaType.AUDIO = 1;
MediaType.VIDEO = 2; // Treeshaking safe.

var PlayerState = function PlayerState() {};

PlayerState.IDLE = 1;
PlayerState.CUED = 2;
PlayerState.PLAYING = 3;
PlayerState.PAUSED = 4;
PlayerState.BUFFERING = 5;
PlayerState.ENDED = 6; // Treeshaking safe.

var VideoQuality = function VideoQuality() {};

VideoQuality.UNKNOWN = 0;
VideoQuality.XXS = 144;
VideoQuality.XS = 240;
VideoQuality.S = 360;
VideoQuality.M = 480;
VideoQuality.L = 720;
VideoQuality.XL = 1080;
VideoQuality.XXL = 1440;
VideoQuality.MAX = 2160;

function noop() {}

function assign(tar, src) {
  // @ts-ignore
  for (var k in src) {
    tar[k] = src[k];
  }

  return tar;
}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && typeof a === 'object' || typeof a === 'function';
}

function not_equal(a, b) {
  return a != a ? b == b : a !== b;
}

function subscribe(store) {
  if (store == null) {
    return noop;
  }

  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function get_store_value(store) {
  var value;
  subscribe(store, function (_) {
    return value = _;
  })();
  return value;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function create_slot(definition, ctx, $$scope, fn) {
  if (definition) {
    var slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
    return definition[0](slot_ctx);
  }
}

function get_slot_context(definition, ctx, $$scope, fn) {
  return definition[1] && fn ? assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}

function get_slot_changes(definition, $$scope, dirty, fn) {
  if (definition[2] && fn) {
    var lets = definition[2](fn(dirty));

    if ($$scope.dirty === undefined) {
      return lets;
    }

    if (typeof lets === 'object') {
      var merged = [];
      var len = Math.max($$scope.dirty.length, lets.length);

      for (var i = 0; i < len; i += 1) {
        merged[i] = $$scope.dirty[i] | lets[i];
      }

      return merged;
    }

    return $$scope.dirty | lets;
  }

  return $$scope.dirty;
}

function update_slot(slot, slot_definition, ctx, $$scope, dirty, get_slot_changes_fn, get_slot_context_fn) {
  var slot_changes = get_slot_changes(slot_definition, $$scope, dirty, get_slot_changes_fn);

  if (slot_changes) {
    var slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
    slot.p(slot_context, slot_changes);
  }
}

function exclude_internal_props(props) {
  var result = {};

  for (var k in props) {
    if (k[0] !== '$') result[k] = props[k];
  }

  return result;
}

function set_store_value(store, ret) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ret;
  store.set(value);
  return ret;
}

function action_destroyer(action_result) {
  return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
}

var is_client = typeof window !== 'undefined';
var raf = is_client ? function (cb) {
  return requestAnimationFrame(cb);
} : noop;

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function destroy_each(iterations, detaching) {
  for (var i = 0; i < iterations.length; i += 1) {
    if (iterations[i]) iterations[i].d(detaching);
  }
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function children(element) {
  return Array.from(element.childNodes);
}

function toggle_class(element, name, toggle) {
  element.classList[toggle ? 'add' : 'remove'](name);
}

function custom_event(type, detail) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(type, false, false, detail);
  return e;
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

function get_current_component() {
  if (!current_component) throw new Error("Function called outside component initialization");
  return current_component;
}

function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}

function afterUpdate(fn) {
  get_current_component().$$.after_update.push(fn);
}

function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}

function createEventDispatcher() {
  var component = get_current_component();
  return function (type, detail) {
    var callbacks = component.$$.callbacks[type];

    if (callbacks) {
      // TODO are there situations where events could be dispatched
      // in a server (non-DOM) environment?
      var event = custom_event(type, detail);
      callbacks.slice().forEach(function (fn) {
        fn.call(component, event);
      });
    }
  };
} // TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism


function bubble(component, event) {
  var callbacks = component.$$.callbacks[event.type];

  if (callbacks) {
    callbacks.slice().forEach(function (fn) {
      return fn(event);
    });
  }
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function tick() {
  schedule_update();
  return resolved_promise;
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

var flushing = false;
var seen_callbacks = new Set();

function flush() {
  if (flushing) return;
  flushing = true;

  do {
    // first, call beforeUpdate functions
    // and update components
    for (var i = 0; i < dirty_components.length; i += 1) {
      var component = dirty_components[i];
      set_current_component(component);
      update(component.$$);
    }

    dirty_components.length = 0;

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var _i = 0; _i < render_callbacks.length; _i += 1) {
      var callback = render_callbacks[_i];

      if (!seen_callbacks.has(callback)) {
        // ...so guard against infinite loops
        seen_callbacks.add(callback);
        callback();
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
  flushing = false;
  seen_callbacks.clear();
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();
var outros;

function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros // parent group

  };
}

function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }

  outros = outros.p;
}

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function transition_out(block, local, detach, callback) {
  if (block && block.o) {
    if (outroing.has(block)) return;
    outroing.add(block);
    outros.c.push(function () {
      outroing.delete(block);

      if (callback) {
        if (detach) block.d(1);
        callback();
      }
    });
    block.o(local);
  }
}

var globals = typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : global;

function get_spread_update(levels, updates) {
  var update = {};
  var to_null_out = {};
  var accounted_for = {
    $$scope: 1
  };
  var i = levels.length;

  while (i--) {
    var o = levels[i];
    var n = updates[i];

    if (n) {
      for (var key in o) {
        if (!(key in n)) to_null_out[key] = 1;
      }

      for (var _key2 in n) {
        if (!accounted_for[_key2]) {
          update[_key2] = n[_key2];
          accounted_for[_key2] = 1;
        }
      }

      levels[i] = n;
    } else {
      for (var _key3 in o) {
        accounted_for[_key3] = 1;
      }
    }
  }

  for (var _key4 in to_null_out) {
    if (!(_key4 in update)) update[_key4] = undefined;
  }

  return update;
}

function get_spread_object(spread_props) {
  return typeof spread_props === 'object' && spread_props !== null ? spread_props : {};
}

function create_component(block) {
  block && block.c();
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      var nodes = children(options.target); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteComponent = /*#__PURE__*/function () {
  function SvelteComponent() {
    _classCallCheck(this, SvelteComponent);
  }

  _createClass(SvelteComponent, [{
    key: "$destroy",
    value: function $destroy() {
      destroy_component(this, 1);
      this.$destroy = noop;
    }
  }, {
    key: "$on",
    value: function $on(type, callback) {
      var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
      callbacks.push(callback);
      return function () {
        var index = callbacks.indexOf(callback);
        if (index !== -1) callbacks.splice(index, 1);
      };
    }
  }, {
    key: "$set",
    value: function $set() {// overridden by instance, if it has props
    }
  }]);

  return SvelteComponent;
}();

var subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */

function readable(value, start) {
  return {
    subscribe: writable(value, start).subscribe
  };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */


function writable(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var stop;
  var subscribers = [];

  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;

      if (stop) {
        // store is ready
        var run_queue = !subscriber_queue.length;

        for (var i = 0; i < subscribers.length; i += 1) {
          var s = subscribers[i];
          s[1]();
          subscriber_queue.push(s, value);
        }

        if (run_queue) {
          for (var _i2 = 0; _i2 < subscriber_queue.length; _i2 += 2) {
            subscriber_queue[_i2][0](subscriber_queue[_i2 + 1]);
          }

          subscriber_queue.length = 0;
        }
      }
    }
  }

  function update(fn) {
    set(fn(value));
  }

  function subscribe(run) {
    var invalidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    var subscriber = [run, invalidate];
    subscribers.push(subscriber);

    if (subscribers.length === 1) {
      stop = start(set) || noop;
    }

    run(value);
    return function () {
      var index = subscribers.indexOf(subscriber);

      if (index !== -1) {
        subscribers.splice(index, 1);
      }

      if (subscribers.length === 0) {
        stop();
        stop = null;
      }
    };
  }

  return {
    set: set,
    update: update,
    subscribe: subscribe
  };
}

function derived(stores, fn, initial_value) {
  var single = !Array.isArray(stores);
  var stores_array = single ? [stores] : stores;
  var auto = fn.length < 2;
  return readable(initial_value, function (set) {
    var inited = false;
    var values = [];
    var pending = 0;
    var cleanup = noop;

    var sync = function sync() {
      if (pending) {
        return;
      }

      cleanup();
      var result = fn(single ? values[0] : values, set);

      if (auto) {
        set(result);
      } else {
        cleanup = is_function(result) ? result : noop;
      }
    };

    var unsubscribers = stores_array.map(function (store, i) {
      return subscribe(store, function (value) {
        values[i] = value;
        pending &= ~(1 << i);

        if (inited) {
          sync();
        }
      }, function () {
        pending |= 1 << i;
      });
    });
    inited = true;
    sync();
    return function stop() {
      run_all(unsubscribers);
      cleanup();
    };
  });
}

var currentPlayer = writable(null); // eslint-disable-next-line no-param-reassign

var set_style = function set_style(el, prop) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (el) el.style[prop] = value;
};

var get_computed_style = function get_computed_style(el) {
  return el ? window.getComputedStyle(el) : null;
};

var get_computed_width = function get_computed_width(el) {
  return el ? parseFloat(get_computed_style(el).width) : 0;
};

var is_null = function is_null(input) {
  return input === null;
};

var is_undefined = function is_undefined(input) {
  return typeof input === 'undefined';
};

var is_null_or_undefined = function is_null_or_undefined(input) {
  return is_null(input) || is_undefined(input);
};

var get_constructor = function get_constructor(input) {
  return !is_null_or_undefined(input) ? input.constructor : null;
};

var is_object = function is_object(input) {
  return get_constructor(input) === Object;
};

var is_number = function is_number(input) {
  return get_constructor(input) === Number && !Number.isNaN(input);
};

var is_string = function is_string(input) {
  return get_constructor(input) === String;
};

var is_boolean = function is_boolean(input) {
  return get_constructor(input) === Boolean;
};

var is_function$1 = function is_function$1(input) {
  return get_constructor(input) === Function;
};

var is_array = function is_array(input) {
  return Array.isArray(input);
};

var is_instance_of = function is_instance_of(input, constructor) {
  return Boolean(input && constructor && input instanceof constructor);
};

function try_parse_json(json, onFail) {
  try {
    return JSON.parse(json);
  } catch (e) {
    if (onFail) onFail(e);
    return null;
  }
}

var is_json_or_obj = function is_json_or_obj(input) {
  if (!input) return false;
  return is_object(input) || input.startsWith('{');
};

var obj_or_try_parse_json = function obj_or_try_parse_json(input) {
  if (is_object(input)) return input;
  return try_parse_json(input);
};
/* eslint-disable max-len */


var IS_CLIENT = typeof window !== 'undefined';
var UA = IS_CLIENT && window.navigator.userAgent.toLowerCase();
var IS_IE = UA && /msie|trident/.test(UA);
var IS_IOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var IS_ANDROID = UA && /android/.test(UA);
var IS_EDGE = UA && UA.indexOf('edge/') > 0;
var IS_CHROME = UA && /chrome\/\d+/.test(UA) && !IS_EDGE;
var IS_IPHONE = IS_CLIENT && /(iPhone|iPod)/gi.test(navigator.platform);
var IS_MOBILE = IS_IOS || IS_ANDROID; // @see https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1633500-webkitenterfullscreen

var can_fullscreen_video = function can_fullscreen_video() {
  if (!IS_CLIENT) return false;
  var video = element('video');
  return is_function$1(video.webkitEnterFullscreen);
};

var can_play_hls_natively = function can_play_hls_natively() {
  if (!IS_CLIENT) return false;
  var video = element('video');
  return video.canPlayType('application/vnd.apple.mpegurl');
}; // Chrome
// @see https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture


var can_use_pip_in_chrome = function can_use_pip_in_chrome() {
  if (!IS_CLIENT) return false;
  var video = element('video');
  return !!document.pictureInPictureEnabled && !video.disablePictureInPicture;
}; // Safari
// iPhone safari appears to "support" PiP through the check, however PiP does not function.
// @see https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls


var can_use_pip_in_safari = function can_use_pip_in_safari() {
  if (!IS_CLIENT) return false;
  var video = element('video');
  return is_function$1(video.webkitSupportsPresentationMode) && is_function$1(video.webkitSetPresentationMode) && !IS_IPHONE;
};

var can_use_pip = function can_use_pip() {
  return can_use_pip_in_chrome() || can_use_pip_in_safari();
};
/**
 * To detect autoplay, we create a video element and call play on it, if it is `paused` after
 * a `play()` call, autoplay is supported. Although this unintuitive, it works across browsers
 * and is currently the lightest way to detect autoplay without using a data source.
 *
 * @see https://github.com/ampproject/amphtml/blob/9bc8756536956780e249d895f3e1001acdee0bc0/src/utils/video.js#L25
 */


var can_autoplay = function can_autoplay() {
  var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var playsinline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!IS_CLIENT) return false;
  var video = element('video');

  if (muted) {
    video.setAttribute('muted', '');
    video.muted = true;
  }

  if (playsinline) {
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsinline = true;
    video.webkitPlaysinline = true;
  }

  video.setAttribute('height', '0');
  video.setAttribute('width', '0');
  video.style.position = 'fixed';
  video.style.top = 0;
  video.style.width = 0;
  video.style.height = 0;
  video.style.opacity = 0; // Promise wrapped this way to catch both sync throws and async rejections.
  // More info: https://github.com/tc39/proposal-promise-try

  new Promise(function (resolve) {
    return resolve(video.play());
  }).catch(noop);
  return Promise.resolve(!video.paused);
};

var try_decode_uri_component = function try_decode_uri_component(component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!IS_CLIENT) return fallback;

  try {
    return window.decodeURIComponent(component);
  } catch (e) {
    return fallback;
  }
}; // eslint-disable-next-line max-len
// @see https://github.com/ampproject/amphtml/blob/c7c46cec71bac92f5c5da31dcc6366c18577f566/src/url-parse-query-string.js#L31


var QUERY_STRING_REGEX = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g;

var parse_query_string = function parse_query_string(qs) {
  var params = Object.create(null);
  if (!qs) return params;
  var match; // eslint-disable-next-line no-cond-assign

  while (match = QUERY_STRING_REGEX.exec(qs)) {
    var name = try_decode_uri_component(match[1], match[1]).replace('[]', '');
    var value = match[2] ? try_decode_uri_component(match[2].replace(/\+/g, ' '), match[2]) : '';
    var currValue = params[name];
    if (currValue && !is_array(currValue)) params[name] = [currValue];
    currValue ? params[name].push(value) : params[name] = value;
  }

  return params;
};

var serialize_query_string = function serialize_query_string(params) {
  var qs = [];

  var appendQueryParam = function appendQueryParam(param, v) {
    qs.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(v)));
  };

  Object.keys(params).forEach(function (param) {
    var value = params[param];
    if (is_null_or_undefined(value)) return;

    if (is_array(value)) {
      value.forEach(function (v) {
        return appendQueryParam(param, v);
      });
    } else {
      appendQueryParam(param, value);
    }
  });
  return qs.join('&');
};

var apppend_querystring_to_url = function apppend_querystring_to_url(url, qs) {
  if (!qs) return url;
  var mainAndQuery = url.split('?', 2);
  return mainAndQuery[0] + (mainAndQuery[1] ? "?".concat(mainAndQuery[1], "&").concat(qs) : "?".concat(qs));
};

var add_params_to_url = function add_params_to_url(url, params) {
  return apppend_querystring_to_url(url, serialize_query_string(params));
};

var prefetch = function prefetch(rel, url, as) {
  if (!IS_CLIENT) return false;
  var link = element('link');
  link.rel = rel;
  link.href = url;
  if (as) link.as = as;
  link.crossorigin = true;
  document.head.append(link);
  return true;
};

var decode_json = function decode_json(data) {
  return is_json_or_obj(data) && obj_or_try_parse_json(data);
};

var decode_query_string = function decode_query_string(data) {
  return is_string(data) && parse_query_string(data);
};

var load_script = function load_script(src, onLoad, onError) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = onLoad;
  script.onerror = onError;
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
};
/**
 * Load image avoiding xhr/fetch CORS issues. Server status can't be obtained this way
 * unfortunately, so this uses "naturalWidth" to determine if the image has been loaded. By
 * default it checks if it is at least 1px.
 */


var load_image = function load_image(src) {
  var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Promise(function (resolve, reject) {
    var image = new Image();

    var handler = function handler() {
      delete image.onload;
      delete image.onerror;
      image.naturalWidth >= minWidth ? resolve(image) : reject(image);
    };

    Object.assign(image, {
      onload: handler,
      onerror: handler,
      src: src
    });
  });
}; // @see https://github.com/CookPete/react-player/blob/master/src/utils.js#L64


var load_library = function load_library(url, global) {
  if (window[global]) return Promise.resolve(window[global]);
  return new Promise(function (resolve, reject) {
    var onLoad = function onLoad() {
      resolve(window[global]);
    };

    var onError = function onError(error) {
      reject(error);
    };

    load_script(url, onLoad, onError);
  });
};

var create_prop = function create_prop(object, key, descriptor) {
  return Object.defineProperty(object, key, descriptor);
};

var deferred = function deferred() {
  var resolve;
  var reject;
  var promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};

var is_store = function is_store(store) {
  return store && is_function$1(store.subscribe);
};

var safe_get = function safe_get(v) {
  return is_store(v) ? get_store_value(v) : v;
}; // Private is "private" to the component who instantiates it, when it is exposed publically
// the set method should be removed. The utility `make_private_stores_readonly` does exactly
// this. This is also what `map_store_to_component` below uses.


var make_store_private = function make_store_private(store) {
  return _objectSpread(_objectSpread({}, store), {}, {
    private: true
  });
};

var add_condition_to_store = function add_condition_to_store(store, condition) {
  return _objectSpread(_objectSpread({}, store), {}, {
    set: function set(value) {
      if (safe_get(condition)) store.set(value);
    },
    forceSet: store.set
  });
};

var private_writable = function private_writable(initialValue) {
  return make_store_private(writable(initialValue));
};

var writable_if = function writable_if(initialValue, condition) {
  return add_condition_to_store(writable(initialValue), condition);
};

var private_writable_if = function private_writable_if(initialValue, condition) {
  return make_store_private(writable_if(initialValue, condition));
};

var indexable = function indexable(bounds) {
  var store = writable(-1);
  return _objectSpread(_objectSpread({}, store), {}, {
    subscribe: derived([store, bounds], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          $value = _ref2[0],
          $bounds = _ref2[1];

      if (!$bounds || $bounds.length === 0) return -1;
      if ($value >= 0 && $value < $bounds.length) return $value;
      return -1;
    }).subscribe
  });
};

var rangeable = function rangeable(initialValue, lowerBound, upperBound) {
  var store = writable(initialValue);
  return _objectSpread(_objectSpread({}, store), {}, {
    set: function set(value) {
      store.set(Math.max(safe_get(lowerBound), Math.min(value, safe_get(upperBound))));
    }
  });
};

var rangeable_if = function rangeable_if(initialValue, lowerBound, upperBound, condition) {
  return add_condition_to_store(rangeable(initialValue, lowerBound, upperBound), condition);
};

var selectable = function selectable(initialValue, values) {
  var newValue;
  var store = writable(initialValue);
  return _objectSpread(_objectSpread({}, store), {}, {
    subscribe: derived([store, values], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          $value = _ref4[0],
          $values = _ref4[1];

      if (!$values) {
        newValue = null;
      }

      if ($values.includes($value)) {
        newValue = $value;
      }

      return newValue;
    }).subscribe
  });
};

var selectable_if = function selectable_if(initialValue, values, condition) {
  return add_condition_to_store(selectable(initialValue, values), condition);
};

var make_store_readonly = function make_store_readonly(store) {
  return {
    subscribe: store.subscribe
  };
};

var make_private_stores_readonly = function make_private_stores_readonly(stores) {
  var result = {};
  Object.keys(stores).forEach(function (name) {
    var store = stores[name];
    result[name] = store.private ? make_store_readonly(store) : store;
  });
  return result;
};

var map_store_to_component = function map_store_to_component(comp, stores) {
  var canWrite = {};
  var component = comp || get_current_component();
  create_prop(component, 'getStore', {
    get: function get() {
      return function () {
        return make_private_stores_readonly(stores);
      };
    },
    configurable: true
  });
  component.$$.on_destroy.push(function () {
    Object.keys(stores).forEach(function (prop) {
      delete component[prop];
    });
    delete component.getStore;
    canWrite = {};
  });

  var onUpdateProp = function onUpdateProp(prop, newValue) {
    var shouldFlush = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!canWrite[prop] || !not_equal(get_store_value(stores[prop]), newValue)) return;
    stores[prop].set(newValue);
    if (shouldFlush) flush();
  };

  Object.keys(stores).forEach(function (prop) {
    var store = stores[prop];
    canWrite[prop] = !!store.set && !store.private;
    create_prop(component, prop, {
      get: function get() {
        return get_store_value(store);
      },
      set: canWrite[prop] ? function (v) {
        onUpdateProp(prop, v, true);
      } : undefined,
      configurable: true
    });
  }); // onPropsChange

  return function (props) {
    return Object.keys(props).forEach(function (prop) {
      onUpdateProp(prop, props[prop]);
    });
  };
};

function vAspectRatio(node, initialAspectRatio) {
  var update = function update(newAspectRatio) {
    if (!newAspectRatio) {
      set_style(node, 'paddingBottom');
      return;
    }

    var _newAspectRatio$split = newAspectRatio.split(':'),
        _newAspectRatio$split2 = _slicedToArray(_newAspectRatio$split, 2),
        width = _newAspectRatio$split2[0],
        height = _newAspectRatio$split2[1];

    set_style(node, 'paddingBottom', "".concat(100 / width * height, "%"));
  };

  update(initialAspectRatio);
  return {
    update: update,
    destroy: function destroy() {
      update(null);
    }
  };
} // Player defaults used when the `src` changes or `resetStore` is called.


var playerDefaults = function playerDefaults() {
  return {
    paused: true,
    playing: false,
    seeking: false,
    rebuilding: false,
    internalTime: 0,
    currentTime: 0,
    title: '',
    duration: 0,
    buffered: 0,
    mediaId: null,
    currentSrc: null,
    buffering: false,
    videoQuality: VideoQuality.UNKNOWN,
    videoQualities: [],
    playbackRate: 1,
    playbackRates: [1],
    playbackStarted: false,
    playbackEnded: false,
    playbackReady: false,
    isLive: false,
    nativePoster: null,
    isControlsActive: true
  };
};

var _resetStore = function resetStore(store) {
  var defaults = playerDefaults();
  Object.keys(defaults).forEach(function (prop) {
    return store[prop] && store[prop].set(defaults[prop]);
  });
};

var fillStore = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = store.canAutoplay;
            _context.next = 3;
            return can_autoplay(false);

          case 3:
            _context.t1 = _context.sent;

            _context.t0.set.call(_context.t0, _context.t1);

            _context.t2 = store.canMutedAutoplay;
            _context.next = 8;
            return can_autoplay(true);

          case 8:
            _context.t3 = _context.sent;

            _context.t2.set.call(_context.t2, _context.t3);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fillStore(_x) {
    return _ref5.apply(this, arguments);
  };
}();

var buildStandardStore = function buildStandardStore(player) {
  var store = {};
  var defaults = playerDefaults();
  store.playbackReady = private_writable(defaults.playbackReady);
  store.rebuilding = private_writable_if(defaults.rebuilding, store.playbackReady);
  store.canAutoplay = private_writable(false);
  store.canMutedAutoplay = private_writable(false);
  store.canInteract = derived([store.playbackReady, store.rebuilding], function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        $playbackReady = _ref7[0],
        $rebuilding = _ref7[1];

    return $playbackReady && !$rebuilding;
  }); // --------------------------------------------------------------
  // Native
  // --------------------------------------------------------------

  store.useNativeView = writable(true);
  store.useNativeControls = writable(true);
  store.useNativeCaptions = writable(true);
  store.nativePoster = private_writable(defaults.nativePoster); // --------------------------------------------------------------
  // Src
  // --------------------------------------------------------------

  store.src = writable(null);
  store.mediaId = private_writable(defaults.mediaId);
  store.poster = writable(null);
  store.provider = private_writable(null);
  store.providers = writable([]);
  store.providerConfig = writable({});
  store.providerVersion = writable('latest');
  store.origin = private_writable(null);
  store.title = private_writable(defaults.title);
  store.currentSrc = private_writable(defaults.currentSrc);
  store.Provider = derived([store.src, store.providers], function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        $src = _ref9[0],
        $providers = _ref9[1];

    return $providers.find(function (p) {
      return p.canPlay($src);
    });
  });
  store.canSetPoster = derived(store.provider, function ($provider) {
    return $provider && is_function$1($provider.setPoster);
  }); // --------------------------------------------------------------
  // Metadata
  // --------------------------------------------------------------

  store.mediaType = private_writable(MediaType.NONE);
  store.isAudio = derived(store.mediaType, function ($mediaType) {
    return $mediaType === MediaType.AUDIO;
  });
  store.isVideo = derived(store.mediaType, function ($mediaType) {
    return $mediaType === MediaType.VIDEO;
  });
  store.isLive = private_writable(false);
  store.playbackRates = private_writable(defaults.playbackRates);
  store.videoQualities = private_writable(defaults.videoQualities);
  store.duration = private_writable(defaults.duration); // Used by @vime-js/complete.
  // eslint-disable-next-line no-underscore-dangle

  store._posterPlugin = writable(false);
  store.isVideoView = derived( // eslint-disable-next-line no-underscore-dangle
  [store.poster, store.nativePoster, store.canSetPoster, store._posterPlugin, store.isVideo], function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 5),
        $poster = _ref11[0],
        $nativePoster = _ref11[1],
        $canSetPoster = _ref11[2],
        $plugin = _ref11[3],
        $isVideo = _ref11[4];

    return !!(($canSetPoster || $plugin) && ($poster || $nativePoster)) || $isVideo;
  });
  store.isVideoReady = derived([store.playbackReady, store.isVideoView], function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        $playbackReady = _ref13[0],
        $isVideoView = _ref13[1];

    return $playbackReady && $isVideoView;
  }); // --------------------------------------------------------------
  // Playback
  // --------------------------------------------------------------

  store.canSetPlaybackRate = derived([store.provider, store.playbackRates], function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
        $provider = _ref15[0],
        $playbackRates = _ref15[1];

    return $provider && $playbackRates.length > 1 && is_function$1($provider.setPlaybackRate);
  });
  store.canSetVideoQuality = derived([store.provider, store.isVideo, store.videoQualities], function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 3),
        $provider = _ref17[0],
        $isVideo = _ref17[1],
        $videoQualities = _ref17[2];

    return $provider && $isVideo && $videoQualities.length > 0 && is_function$1($provider.setVideoQuality);
  });
  store.paused = writable(defaults.paused);
  store.playbackRate = selectable_if(defaults.playbackRate, store.playbackRates, store.canSetPlaybackRate);
  store.videoQuality = selectable_if(defaults.videoQuality, store.videoQualities, store.canSetVideoQuality);
  store.currentTime = rangeable(defaults.currentTime, 0, store.duration);
  store.internalTime = private_writable(defaults.internalTime);
  store.muted = writable(false);
  store.volume = rangeable_if(30, 0, 100, !IS_MOBILE);
  store.buffered = private_writable(defaults.buffered);
  store.isControlsEnabled = writable(true);
  store.isControlsActive = private_writable(defaults.isControlsActive);
  store.progress = derived([store.currentTime, store.duration, store.buffered], function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 3),
        $currentTime = _ref19[0],
        $duration = _ref19[1],
        $buffered = _ref19[2];

    return {
      played: {
        seconds: $currentTime,
        percent: $currentTime / $duration * 100
      },
      buffered: {
        seconds: $buffered,
        percent: $buffered / $duration * 100
      }
    };
  }); // --------------------------------------------------------------
  // State
  // --------------------------------------------------------------

  store.playing = private_writable(defaults.playing);
  store.buffering = private_writable(defaults.buffering);
  store.playbackEnded = private_writable(defaults.playbackEnded);
  store.playbackStarted = private_writable(defaults.playbackStarted);
  store.seeking = private_writable(defaults.seeking);
  store.isPlayerActive = private_writable(false);
  store.state = derived([store.playbackStarted, store.playbackEnded, store.paused, store.buffering, store.playbackReady], function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 5),
        $playbackStarted = _ref21[0],
        $playbackEnded = _ref21[1],
        $paused = _ref21[2],
        $buffering = _ref21[3],
        $playbackReady = _ref21[4];

    if ($playbackEnded) {
      return PlayerState.ENDED;
    }

    if ($buffering) {
      return PlayerState.BUFFERING;
    }

    if ($playbackStarted && $paused) {
      return PlayerState.PAUSED;
    }

    if ($playbackStarted) {
      return PlayerState.PLAYING;
    }

    if ($playbackReady) {
      return PlayerState.CUED;
    }

    return PlayerState.IDLE;
  }); // --------------------------------------------------------------
  // Tracks
  // --------------------------------------------------------------

  store.canSetTracks = derived(store.provider, function ($provider) {
    return $provider && is_function$1($provider.setTracks);
  }); // Don't block writing of `tracks` as it might be stored and used by a provider when possible.

  store.tracks = writable([]);
  store.canSetTrack = derived([store.provider, store.tracks], function (_ref22) {
    var _ref23 = _slicedToArray(_ref22, 2),
        $provider = _ref23[0],
        $tracks = _ref23[1];

    return $provider && $tracks && $tracks.length > 0 && is_function$1($provider.setTrack);
  }); // Can't block current track with `canSetTrack` because it'll stop @vime-js/complete from updating
  // the value when a plugin is managing captions.

  store.currentTrackIndex = indexable(store.tracks);
  store.currentTrack = derived([store.tracks, store.currentTrackIndex], function (_ref24) {
    var _ref25 = _slicedToArray(_ref24, 2),
        $tracks = _ref25[0],
        $index = _ref25[1];

    return $index >= 0 ? $tracks[$index] : null;
  });
  store.isCaptionsActive = derived([store.playbackReady, store.isAudio, store.currentTrackIndex], function (_ref26) {
    var _ref27 = _slicedToArray(_ref26, 3),
        $playbackReady = _ref27[0],
        $isAudio = _ref27[1],
        $currentTrackIndex = _ref27[2];

    return $playbackReady && !$isAudio && $currentTrackIndex !== -1;
  }); // TODO: add cues support (cues, currentCueIndex, currentCue, activeCues).
  // --------------------------------------------------------------
  // Picture in Picture
  // --------------------------------------------------------------

  store.canSetPiP = derived([store.isVideoReady, store.provider], function (_ref28) {
    var _ref29 = _slicedToArray(_ref28, 2),
        $isVideoReady = _ref29[0],
        $provider = _ref29[1];

    return $isVideoReady && $provider && $provider.supportsPiP() && is_function$1($provider.setPiP);
  });
  store.isPiPActive = private_writable(false); // --------------------------------------------------------------
  // Fullscreen
  // --------------------------------------------------------------
  // Set in the Player.

  store.canSetFullscreen = private_writable(false);
  store.isFullscreenActive = private_writable(false); // --------------------------------------------------------------
  // Options
  // --------------------------------------------------------------

  store.autopause = writable(true);
  store.aspectRatio = writable('16:9');
  store.playsinline = writable(true);
  store.autoplay = writable(false);
  store.loop = writable(false);
  fillStore(store);
  return {
    store: store,
    onPropsChange: map_store_to_component(player, store),
    resetStore: function resetStore() {
      return _resetStore(store);
    }
  };
};
/* Users/rahim/Desktop/Projects/vime/vime-1.x/packages/vime-lite/src/Embed.svelte generated by Svelte v3.24.0 */


function add_css() {
  var style = element("style");
  style.id = "svelte-7bba2w-style";
  style.textContent = "iframe.svelte-7bba2w{position:absolute;top:0;left:0;border:0;-webkit-user-select:none;user-select:none;width:100%;height:100%}";
  append(document.head, style);
}

function create_fragment(ctx) {
  var iframe_1;
  var iframe_1_src_value;
  var mounted;
  var dispose;
  return {
    c: function c() {
      iframe_1 = element("iframe");
      attr(iframe_1, "id",
      /*id*/
      ctx[3]);
      attr(iframe_1, "title",
      /*title*/
      ctx[0]);
      if (iframe_1.src !== (iframe_1_src_value =
      /*srcWithParams*/
      ctx[2])) attr(iframe_1, "src", iframe_1_src_value);
      iframe_1.allowFullscreen = "1";
      attr(iframe_1, "allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
      attr(iframe_1, "class", "svelte-7bba2w");
    },
    m: function m(target, anchor) {
      insert(target, iframe_1, anchor);
      /*iframe_1_binding*/

      ctx[15](iframe_1);

      if (!mounted) {
        dispose = [listen(window, "message",
        /*onMessage*/
        ctx[4]), listen(iframe_1, "load",
        /*load_handler*/
        ctx[14])];
        mounted = true;
      }
    },
    p: function p(ctx, _ref30) {
      var _ref31 = _slicedToArray(_ref30, 1),
          dirty = _ref31[0];

      if (dirty &
      /*title*/
      1) {
        attr(iframe_1, "title",
        /*title*/
        ctx[0]);
      }

      if (dirty &
      /*srcWithParams*/
      4 && iframe_1.src !== (iframe_1_src_value =
      /*srcWithParams*/
      ctx[2])) {
        attr(iframe_1, "src", iframe_1_src_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(iframe_1);
      /*iframe_1_binding*/

      ctx[15](null);
      mounted = false;
      run_all(dispose);
    }
  };
}

var idCount = 0;
var PRECONNECTED = [];

function instance($$self, $$props, $$invalidate) {
  var iframe = null;
  var srcWithParams = null; // eslint-disable-next-line prefer-const

  idCount += 1;
  var id = "vime-embed-".concat(idCount);
  var dispatch = createEventDispatcher();
  var Event = {
    SRC_CHANGE: "srcchange",
    MESSAGE: "message",
    DATA: "data",
    REBUILD: "rebuild"
  };
  var _$$props$src = $$props.src,
      src = _$$props$src === void 0 ? null : _$$props$src;
  var _$$props$title = $$props.title,
      title = _$$props$title === void 0 ? null : _$$props$title;
  var _$$props$params = $$props.params,
      params = _$$props$params === void 0 ? {} : _$$props$params;
  var _$$props$origin = $$props.origin,
      origin = _$$props$origin === void 0 ? null : _$$props$origin;
  var _$$props$preconnectio = $$props.preconnections,
      preconnections = _$$props$preconnectio === void 0 ? [] : _$$props$preconnectio;
  var _$$props$decoder = $$props.decoder,
      decoder = _$$props$decoder === void 0 ? null : _$$props$decoder;

  var getId = function getId() {
    return id;
  };

  var getIframe = function getIframe() {
    return iframe;
  };

  var getSrc = function getSrc() {
    return srcWithParams;
  };

  var postMessage = function postMessage(message, target) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify(message), target || origin || "*");
  };

  var originMatches = function originMatches(e) {
    if (!iframe || e.source !== iframe.contentWindow) return false;
    return is_string(origin) && origin === e.origin;
  };

  var onMessage = function onMessage(e) {
    if (!originMatches(e)) return;
    dispatch(Event.MESSAGE, e);
    var data = decoder ? decoder(e.data) : null;
    if (data) dispatch(Event.DATA, data);
  };

  var hasMounted = false;
  onMount(function () {
    $$invalidate(16, hasMounted = true);
  });

  function load_handler(event) {
    bubble($$self, event);
  }

  function iframe_1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      iframe = $$value;
      $$invalidate(1, iframe);
    });
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(5, src = $$props.src);
    if ("title" in $$props) $$invalidate(0, title = $$props.title);
    if ("params" in $$props) $$invalidate(6, params = $$props.params);
    if ("origin" in $$props) $$invalidate(7, origin = $$props.origin);
    if ("preconnections" in $$props) $$invalidate(8, preconnections = $$props.preconnections);
    if ("decoder" in $$props) $$invalidate(9, decoder = $$props.decoder);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*hasMounted, src, params*/
    65632) {
      if (hasMounted) $$invalidate(2, srcWithParams = src ? add_params_to_url(src, params) : null);
    }

    if ($$self.$$.dirty &
    /*hasMounted, srcWithParams*/
    65540) {
      if (hasMounted) dispatch(Event.SRC_CHANGE, srcWithParams);
    }

    if ($$self.$$.dirty &
    /*hasMounted, srcWithParams*/
    65540) {
      if (hasMounted && srcWithParams) dispatch(Event.REBUILD);
    }

    if ($$self.$$.dirty &
    /*hasMounted, srcWithParams, iframe*/
    65542) {
      if (hasMounted && srcWithParams && !iframe && !PRECONNECTED.includes(srcWithParams)) {
        if (prefetch("preconnect", srcWithParams)) PRECONNECTED.push(srcWithParams);
      }
    }

    if ($$self.$$.dirty &
    /*hasMounted, preconnections*/
    65792) {
      // TODO: improve preconnections
      // @see https://github.com/ampproject/amphtml/blob/master/src/preconnect.js
      if (hasMounted) {
        preconnections.filter(function (p) {
          return !PRECONNECTED.includes(p);
        }).forEach(function (url) {
          if (prefetch("preconnect", url)) PRECONNECTED.push(url);
        });
      }
    }
  };

  return [title, iframe, srcWithParams, id, onMessage, src, params, origin, preconnections, decoder, getId, getIframe, getSrc, postMessage, load_handler, iframe_1_binding];
}

var Embed = /*#__PURE__*/function (_SvelteComponent) {
  _inherits(Embed, _SvelteComponent);

  var _super = _createSuper(Embed);

  function Embed(options) {
    var _this;

    _classCallCheck(this, Embed);

    _this = _super.call(this);
    if (!document.getElementById("svelte-7bba2w-style")) add_css();
    init(_assertThisInitialized(_this), options, instance, create_fragment, safe_not_equal, {
      src: 5,
      title: 0,
      params: 6,
      origin: 7,
      preconnections: 8,
      decoder: 9,
      getId: 10,
      getIframe: 11,
      getSrc: 12,
      postMessage: 13
    });
    return _this;
  }

  _createClass(Embed, [{
    key: "getId",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "getIframe",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "getSrc",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "postMessage",
    get: function get() {
      return this.$$.ctx[13];
    }
  }]);

  return Embed;
}(SvelteComponent);
/* Users/rahim/Desktop/Projects/vime/vime-1.x/packages/vime-lite/src/Lazy.svelte generated by Svelte v3.24.0 */


function add_css$1() {
  var style = element("style");
  style.id = "svelte-rzesm5-style";
  style.textContent = "div.svelte-rzesm5{width:100%}";
  append(document.head, style);
}

var get_default_slot_changes = function get_default_slot_changes(dirty) {
  return {
    intersecting: dirty &
    /*intersecting*/
    2
  };
};

var get_default_slot_context = function get_default_slot_context(ctx) {
  return {
    intersecting:
    /*intersecting*/
    ctx[1]
  };
};

function create_fragment$1(ctx) {
  var div;
  var current;
  var default_slot_template =
  /*$$slots*/
  ctx[4].default;
  var default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[3], get_default_slot_context);
  return {
    c: function c() {
      div = element("div");
      if (default_slot) default_slot.c();
      attr(div, "class", "svelte-rzesm5");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      if (default_slot) {
        default_slot.m(div, null);
      }
      /*div_binding*/


      ctx[5](div);
      current = true;
    },
    p: function p(ctx, _ref32) {
      var _ref33 = _slicedToArray(_ref32, 1),
          dirty = _ref33[0];

      if (default_slot) {
        if (default_slot.p && dirty &
        /*$$scope, intersecting*/
        10) {
          update_slot(default_slot, default_slot_template, ctx,
          /*$$scope*/
          ctx[3], dirty, get_default_slot_changes, get_default_slot_context);
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);
      /*div_binding*/

      ctx[5](null);
    }
  };
}

function instance$1($$self, $$props, $$invalidate) {
  var el;
  var intersecting = false;
  var _$$props$threshold = $$props.threshold,
      threshold = _$$props$threshold === void 0 ? 0.75 : _$$props$threshold;
  onMount(function () {
    if (typeof IntersectionObserver !== "undefined") {
      var observer = new IntersectionObserver(function (entries) {
        $$invalidate(1, intersecting = entries[0].isIntersecting);
        if (intersecting) observer.unobserve(el);
      }, {
        threshold: threshold
      });
      observer.observe(el);
      return function () {
        return observer.unobserve(el);
      };
    }

    function onScroll() {
      var rect = el.getBoundingClientRect();
      $$invalidate(1, intersecting = rect.bottom > 0 && rect.right > 0 && rect.top * (1 + threshold) < window.innerHeight && rect.left < window.innerWidth);
      if (intersecting) window.removeEventListener("scroll", onScroll);
    }

    window.addEventListener("scroll", onScroll);
    return function () {
      return window.removeEventListener("scroll", onScroll);
    };
  });
  var _$$props$$$slots = $$props.$$slots,
      $$slots = _$$props$$$slots === void 0 ? {} : _$$props$$$slots,
      $$scope = $$props.$$scope;

  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      el = $$value;
      $$invalidate(0, el);
    });
  }

  $$self.$set = function ($$props) {
    if ("threshold" in $$props) $$invalidate(2, threshold = $$props.threshold);
    if ("$$scope" in $$props) $$invalidate(3, $$scope = $$props.$$scope);
  };

  return [el, intersecting, threshold, $$scope, $$slots, div_binding];
}

var Lazy = /*#__PURE__*/function (_SvelteComponent2) {
  _inherits(Lazy, _SvelteComponent2);

  var _super2 = _createSuper(Lazy);

  function Lazy(options) {
    var _this2;

    _classCallCheck(this, Lazy);

    _this2 = _super2.call(this);
    if (!document.getElementById("svelte-rzesm5-style")) add_css$1();
    init(_assertThisInitialized(_this2), options, instance$1, create_fragment$1, safe_not_equal, {
      threshold: 2
    });
    return _this2;
  }

  return Lazy;
}(SvelteComponent);
/* Users/rahim/Desktop/Projects/vime/vime-1.x/packages/vime-lite/src/PlayerWrapper.svelte generated by Svelte v3.24.0 */


function add_css$2() {
  var style = element("style");
  style.id = "svelte-y6iyru-style";
  style.textContent = "div.svelte-y6iyru{position:relative}.video.svelte-y6iyru{height:0;overflow:hidden;background:#000}";
  append(document.head, style);
} // (13:0) {:else}


function create_else_block(ctx) {
  var current;
  var default_slot_template =
  /*$$slots*/
  ctx[3].default;
  var default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[5], null);
  return {
    c: function c() {
      if (default_slot) default_slot.c();
    },
    m: function m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }

      current = true;
    },
    p: function p(ctx, dirty) {
      if (default_slot) {
        if (default_slot.p && dirty &
        /*$$scope*/
        32) {
          update_slot(default_slot, default_slot_template, ctx,
          /*$$scope*/
          ctx[5], dirty, null, null);
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
} // (1:0) {#if isEnabled}


function create_if_block(ctx) {
  var lazy;
  var current;
  lazy = new Lazy({
    props: {
      $$slots: {
        default: [create_default_slot, function (_ref34) {
          var intersecting = _ref34.intersecting;
          return {
            7: intersecting
          };
        }, function (_ref35) {
          var intersecting = _ref35.intersecting;
          return intersecting ? 128 : 0;
        }]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(lazy.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(lazy, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var lazy_changes = {};

      if (dirty &
      /*$$scope, el, isEnabled, aspectRatio, intersecting*/
      167) {
        lazy_changes.$$scope = {
          dirty: dirty,
          ctx: ctx
        };
      }

      lazy.$set(lazy_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(lazy.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(lazy.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(lazy, detaching);
    }
  };
} // (3:4) {#if intersecting}


function create_if_block_1(ctx) {
  var div;
  var vAspectRatio_action;
  var current;
  var mounted;
  var dispose;
  var default_slot_template =
  /*$$slots*/
  ctx[3].default;
  var default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[5], null);
  return {
    c: function c() {
      div = element("div");
      if (default_slot) default_slot.c();
      attr(div, "class", "svelte-y6iyru");
      toggle_class(div, "video", !is_null(
      /*aspectRatio*/
      ctx[0]));
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      if (default_slot) {
        default_slot.m(div, null);
      }
      /*div_binding*/


      ctx[4](div);
      current = true;

      if (!mounted) {
        dispose = action_destroyer(vAspectRatio_action = vAspectRatio.call(null, div,
        /*isEnabled*/
        ctx[1] ?
        /*aspectRatio*/
        ctx[0] : null));
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (default_slot) {
        if (default_slot.p && dirty &
        /*$$scope*/
        32) {
          update_slot(default_slot, default_slot_template, ctx,
          /*$$scope*/
          ctx[5], dirty, null, null);
        }
      }

      if (vAspectRatio_action && is_function(vAspectRatio_action.update) && dirty &
      /*isEnabled, aspectRatio*/
      3) vAspectRatio_action.update.call(null,
      /*isEnabled*/
      ctx[1] ?
      /*aspectRatio*/
      ctx[0] : null);

      if (dirty &
      /*is_null, aspectRatio*/
      1) {
        toggle_class(div, "video", !is_null(
        /*aspectRatio*/
        ctx[0]));
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);
      /*div_binding*/

      ctx[4](null);
      mounted = false;
      dispose();
    }
  };
} // (2:2) <Lazy let:intersecting>


function create_default_slot(ctx) {
  var if_block_anchor;
  var current;
  var if_block =
  /*intersecting*/
  ctx[7] && create_if_block_1(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      if (
      /*intersecting*/
      ctx[7]) {
        if (if_block) {
          if_block.p(ctx, dirty);

          if (dirty &
          /*intersecting*/
          128) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

function create_fragment$2(ctx) {
  var current_block_type_index;
  var if_block;
  var if_block_anchor;
  var current;
  var if_block_creators = [create_if_block, create_else_block];
  var if_blocks = [];

  function select_block_type(ctx, dirty) {
    if (
    /*isEnabled*/
    ctx[1]) return 0;
    return 1;
  }

  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, _ref36) {
      var _ref37 = _slicedToArray(_ref36, 1),
          dirty = _ref37[0];

      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];

        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        }

        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

function instance$2($$self, $$props, $$invalidate) {
  var dispatch = createEventDispatcher();
  var el;
  var _$$props$aspectRatio = $$props.aspectRatio,
      aspectRatio = _$$props$aspectRatio === void 0 ? null : _$$props$aspectRatio;
  var _$$props$isEnabled = $$props.isEnabled,
      isEnabled = _$$props$isEnabled === void 0 ? true : _$$props$isEnabled;
  var _$$props$$$slots2 = $$props.$$slots,
      $$slots = _$$props$$$slots2 === void 0 ? {} : _$$props$$$slots2,
      $$scope = $$props.$$scope;

  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      el = $$value;
      $$invalidate(2, el);
    });
  }

  $$self.$set = function ($$props) {
    if ("aspectRatio" in $$props) $$invalidate(0, aspectRatio = $$props.aspectRatio);
    if ("isEnabled" in $$props) $$invalidate(1, isEnabled = $$props.isEnabled);
    if ("$$scope" in $$props) $$invalidate(5, $$scope = $$props.$$scope);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*el*/
    4) {
      if (el) dispatch("mount", el);
    }
  };

  return [aspectRatio, isEnabled, el, $$slots, div_binding, $$scope];
}

var PlayerWrapper = /*#__PURE__*/function (_SvelteComponent3) {
  _inherits(PlayerWrapper, _SvelteComponent3);

  var _super3 = _createSuper(PlayerWrapper);

  function PlayerWrapper(options) {
    var _this3;

    _classCallCheck(this, PlayerWrapper);

    _this3 = _super3.call(this);
    if (!document.getElementById("svelte-y6iyru-style")) add_css$2();
    init(_assertThisInitialized(_this3), options, instance$2, create_fragment$2, safe_not_equal, {
      aspectRatio: 0,
      isEnabled: 1
    });
    return _this3;
  }

  return PlayerWrapper;
}(SvelteComponent);
/* Users/rahim/Desktop/Projects/vime/vime-1.x/packages/vime-lite/src/LitePlayer.svelte generated by Svelte v3.24.0 */


function create_default_slot$1(ctx) {
  var embed_1;
  var current;
  var embed_1_props = {
    decoder:
    /*decoder*/
    ctx[6],
    preconnections:
    /*preconnections*/
    ctx[7],
    src:
    /*embedURL*/
    ctx[4],
    params:
    /*allParams*/
    ctx[9],
    title:
    /*iframeTitle*/
    ctx[5],
    origin:
    /*origin*/
    ctx[3]
  };
  embed_1 = new Embed({
    props: embed_1_props
  });
  /*embed_1_binding*/

  ctx[24](embed_1);
  embed_1.$on("load",
  /*load_handler*/
  ctx[25]);
  embed_1.$on("data",
  /*data_handler*/
  ctx[26]);
  embed_1.$on("message",
  /*message_handler*/
  ctx[27]);
  embed_1.$on("rebuild",
  /*rebuild_handler*/
  ctx[28]);
  embed_1.$on("load",
  /*onLoad*/
  ctx[11]);
  embed_1.$on("data", function () {
    if (is_function(
    /*onData*/
    ctx[8]))
      /*onData*/
      ctx[8].apply(this, arguments);
  });
  embed_1.$on("srcchange",
  /*onReload*/
  ctx[10]);
  return {
    c: function c() {
      create_component(embed_1.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(embed_1, target, anchor);
      current = true;
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      var embed_1_changes = {};
      if (dirty[0] &
      /*decoder*/
      64) embed_1_changes.decoder =
      /*decoder*/
      ctx[6];
      if (dirty[0] &
      /*preconnections*/
      128) embed_1_changes.preconnections =
      /*preconnections*/
      ctx[7];
      if (dirty[0] &
      /*embedURL*/
      16) embed_1_changes.src =
      /*embedURL*/
      ctx[4];
      if (dirty[0] &
      /*allParams*/
      512) embed_1_changes.params =
      /*allParams*/
      ctx[9];
      if (dirty[0] &
      /*iframeTitle*/
      32) embed_1_changes.title =
      /*iframeTitle*/
      ctx[5];
      if (dirty[0] &
      /*origin*/
      8) embed_1_changes.origin =
      /*origin*/
      ctx[3];
      embed_1.$set(embed_1_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(embed_1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(embed_1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*embed_1_binding*/
      ctx[24](null);
      destroy_component(embed_1, detaching);
    }
  };
}

function create_fragment$3(ctx) {
  var playerwrapper;
  var current;
  playerwrapper = new PlayerWrapper({
    props: {
      aspectRatio:
      /*aspectRatio*/
      ctx[1],
      isEnabled:
      /*hasWrapper*/
      ctx[0],
      $$slots: {
        default: [create_default_slot$1]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(playerwrapper.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(playerwrapper, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var playerwrapper_changes = {};
      if (dirty[0] &
      /*aspectRatio*/
      2) playerwrapper_changes.aspectRatio =
      /*aspectRatio*/
      ctx[1];
      if (dirty[0] &
      /*hasWrapper*/
      1) playerwrapper_changes.isEnabled =
      /*hasWrapper*/
      ctx[0];

      if (dirty[0] &
      /*decoder, preconnections, embedURL, allParams, iframeTitle, origin, embed, onData*/
      1020 | dirty[1] &
      /*$$scope*/
      128) {
        playerwrapper_changes.$$scope = {
          dirty: dirty,
          ctx: ctx
        };
      }

      playerwrapper.$set(playerwrapper_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(playerwrapper.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(playerwrapper.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(playerwrapper, detaching);
    }
  };
}

function instance$3($$self, $$props, $$invalidate) {
  var dispatch = createEventDispatcher();
  var Event = {
    READY: "ready",
    TITLE_CHANGE: "titlechange",
    ORIGIN_CHANGE: "originchange",
    EMBED_URL_CHANGE: "embedurlchange",
    ERROR: "error"
  };
  var embed;
  var mediaTitle = null;
  var ready = deferred();
  var initialized = false;
  var _$$props$src2 = $$props.src,
      src = _$$props$src2 === void 0 ? null : _$$props$src2;
  var _$$props$params2 = $$props.params,
      params = _$$props$params2 === void 0 ? {} : _$$props$params2;
  var _$$props$providers = $$props.providers,
      providers = _$$props$providers === void 0 ? [] : _$$props$providers;
  var _$$props$cookies = $$props.cookies,
      cookies = _$$props$cookies === void 0 ? false : _$$props$cookies;
  var _$$props$hasWrapper = $$props.hasWrapper,
      hasWrapper = _$$props$hasWrapper === void 0 ? true : _$$props$hasWrapper;
  var _$$props$aspectRatio2 = $$props.aspectRatio,
      aspectRatio = _$$props$aspectRatio2 === void 0 ? "16:9" : _$$props$aspectRatio2;
  var _$$props$ignoreDefaul = $$props.ignoreDefaultParams,
      ignoreDefaultParams = _$$props$ignoreDefaul === void 0 ? false : _$$props$ignoreDefaul;

  var getOrigin = function getOrigin() {
    return origin;
  };

  var getEmbed = function getEmbed() {
    return embed;
  };

  var getEmbedURL = function getEmbedURL() {
    return embedURL;
  };

  var getTitle = function getTitle() {
    return mediaTitle;
  };

  var getProvider = function getProvider() {
    return Provider;
  };

  var getMediaId = function getMediaId() {
    return Provider ? Provider.extractMediaId(src) : null;
  };

  var sendCommand = /*#__PURE__*/function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(command, args, force) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (Provider) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.prev = 2;

              if (force) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return tick();

            case 6:
              _context2.next = 8;
              return ready.promise;

            case 8:
              embed.postMessage(Provider.buildPostMessage(command, args));
              _context2.next = 13;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](2);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 11]]);
    }));

    return function sendCommand(_x2, _x3, _x4) {
      return _ref38.apply(this, arguments);
    };
  }();

  var onReload = function onReload() {
    ready.promise.catch(noop);
    ready.reject();
    ready = deferred();
    $$invalidate(31, initialized = false);
    ready.promise.then(function () {
      $$invalidate(31, initialized = true);
      dispatch(Event.READY);
    }).catch(function (e) {
      dispatch(Event.ERROR, e);
    });
  };

  var onSrcChange = function onSrcChange() {
    $$invalidate(29, mediaTitle = null);
  };

  var onLoad = function onLoad() {
    if (Provider) Provider.onLoad(embed);
  };

  var onDataHandler = function onDataHandler(e) {
    var data = e.detail;
    if (!data || !Provider) return;
    Provider.resolveReadyState(data, ready, sendCommand);
    if (!mediaTitle) $$invalidate(29, mediaTitle = Provider.extractMediaTitle(data));
  };

  var hasMounted = false;
  onMount(function () {
    $$invalidate(32, hasMounted = true);
  });
  onReload();

  function embed_1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      embed = $$value;
      $$invalidate(2, embed);
    });
  }

  function load_handler(event) {
    bubble($$self, event);
  }

  function data_handler(event) {
    bubble($$self, event);
  }

  function message_handler(event) {
    bubble($$self, event);
  }

  function rebuild_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(12, src = $$props.src);
    if ("params" in $$props) $$invalidate(13, params = $$props.params);
    if ("providers" in $$props) $$invalidate(14, providers = $$props.providers);
    if ("cookies" in $$props) $$invalidate(15, cookies = $$props.cookies);
    if ("hasWrapper" in $$props) $$invalidate(0, hasWrapper = $$props.hasWrapper);
    if ("aspectRatio" in $$props) $$invalidate(1, aspectRatio = $$props.aspectRatio);
    if ("ignoreDefaultParams" in $$props) $$invalidate(16, ignoreDefaultParams = $$props.ignoreDefaultParams);
  };

  var origin;
  var embedURL;
  var Provider;
  var iframeTitle;
  var decoder;
  var preconnections;
  var onData;
  var allParams;

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*src*/
    4096) {
      onSrcChange();
    }

    if ($$self.$$.dirty[0] &
    /*providers, src*/
    20480) {
      $$invalidate(33, Provider = providers.find(function (p) {
        return p.canPlay(src);
      }));
    }

    if ($$self.$$.dirty[0] &
    /*cookies*/
    32768 | $$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(3, origin = Provider ? Provider.buildOrigin(cookies) : null);
    }

    if ($$self.$$.dirty[0] &
    /*src, cookies*/
    36864 | $$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(4, embedURL = Provider ? Provider.buildEmbedURL(src, cookies) : null);
    }

    if ($$self.$$.dirty[0] &
    /*mediaTitle*/
    536870912 | $$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(5, iframeTitle = Provider && mediaTitle ? "".concat(Provider.name, " - ").concat(mediaTitle || "Video Player") : null);
    }

    if ($$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(6, decoder = Provider ? Provider.decoder : null);
    }

    if ($$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(7, preconnections = Provider ? Provider.preconnections : []);
    }

    if ($$self.$$.dirty[0] &
    /*mediaTitle*/
    536870912 | $$self.$$.dirty[1] &
    /*initialized*/
    1) {
      $$invalidate(8, onData = !initialized || !mediaTitle ? onDataHandler : null);
    }

    if ($$self.$$.dirty[0] &
    /*ignoreDefaultParams, params*/
    73728 | $$self.$$.dirty[1] &
    /*Provider*/
    4) {
      $$invalidate(9, allParams = !ignoreDefaultParams && Provider && Provider.defaultParams ? _objectSpread(_objectSpread({}, Provider.defaultParams), params) : params);
    }

    if ($$self.$$.dirty[0] &
    /*src*/
    4096 | $$self.$$.dirty[1] &
    /*hasMounted*/
    2) {
      if (hasMounted) dispatch(Event.SRC_CHANGE, src);
    }

    if ($$self.$$.dirty[0] &
    /*mediaTitle*/
    536870912 | $$self.$$.dirty[1] &
    /*hasMounted*/
    2) {
      if (hasMounted) dispatch(Event.TITLE_CHANGE, mediaTitle);
    }

    if ($$self.$$.dirty[0] &
    /*origin*/
    8 | $$self.$$.dirty[1] &
    /*hasMounted*/
    2) {
      if (hasMounted) dispatch(Event.ORIGIN_CHANGE, origin);
    }

    if ($$self.$$.dirty[0] &
    /*embedURL*/
    16 | $$self.$$.dirty[1] &
    /*hasMounted*/
    2) {
      if (hasMounted) dispatch(Event.EMBED_URL_CHANGE, embedURL);
    }
  };

  return [hasWrapper, aspectRatio, embed, origin, embedURL, iframeTitle, decoder, preconnections, onData, allParams, onReload, onLoad, src, params, providers, cookies, ignoreDefaultParams, getOrigin, getEmbed, getEmbedURL, getTitle, getProvider, getMediaId, sendCommand, embed_1_binding, load_handler, data_handler, message_handler, rebuild_handler];
}

var LitePlayer = /*#__PURE__*/function (_SvelteComponent4) {
  _inherits(LitePlayer, _SvelteComponent4);

  var _super4 = _createSuper(LitePlayer);

  function LitePlayer(options) {
    var _this4;

    _classCallCheck(this, LitePlayer);

    _this4 = _super4.call(this);
    init(_assertThisInitialized(_this4), options, instance$3, create_fragment$3, safe_not_equal, {
      src: 12,
      params: 13,
      providers: 14,
      cookies: 15,
      hasWrapper: 0,
      aspectRatio: 1,
      ignoreDefaultParams: 16,
      getOrigin: 17,
      getEmbed: 18,
      getEmbedURL: 19,
      getTitle: 20,
      getProvider: 21,
      getMediaId: 22,
      sendCommand: 23
    }, [-1, -1]);
    return _this4;
  }

  _createClass(LitePlayer, [{
    key: "src",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(src) {
      this.$set({
        src: src
      });
      flush();
    }
  }, {
    key: "params",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(params) {
      this.$set({
        params: params
      });
      flush();
    }
  }, {
    key: "providers",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(providers) {
      this.$set({
        providers: providers
      });
      flush();
    }
  }, {
    key: "cookies",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(cookies) {
      this.$set({
        cookies: cookies
      });
      flush();
    }
  }, {
    key: "hasWrapper",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(hasWrapper) {
      this.$set({
        hasWrapper: hasWrapper
      });
      flush();
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(aspectRatio) {
      this.$set({
        aspectRatio: aspectRatio
      });
      flush();
    }
  }, {
    key: "ignoreDefaultParams",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(ignoreDefaultParams) {
      this.$set({
        ignoreDefaultParams: ignoreDefaultParams
      });
      flush();
    }
  }, {
    key: "getOrigin",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "getEmbed",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "getEmbedURL",
    get: function get() {
      return this.$$.ctx[19];
    }
  }, {
    key: "getTitle",
    get: function get() {
      return this.$$.ctx[20];
    }
  }, {
    key: "getProvider",
    get: function get() {
      return this.$$.ctx[21];
    }
  }, {
    key: "getMediaId",
    get: function get() {
      return this.$$.ctx[22];
    }
  }, {
    key: "sendCommand",
    get: function get() {
      return this.$$.ctx[23];
    }
  }]);

  return LitePlayer;
}(SvelteComponent);

var NAME = 'YouTube';
var ORIGIN = 'https://www.youtube.com';
var ORIGIN_NO_COOKIES = 'https://www.youtube-nocookie.com';
var SRC = /(?:youtu\.be|youtube|youtube\.com|youtube-nocookie\.com)\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|)((?:\w|-){11})/;
var DECODER = decode_json;
var PRECONNECTIONS = [ORIGIN, ORIGIN_NO_COOKIES, 'https://www.google.com', 'https://googleads.g.doubleclick.net', 'https://static.doubleclick.net', 'https://s.ytimg.com', 'https://i.ytimg.com'];

var build_origin = function build_origin(cookies) {
  return cookies ? ORIGIN : ORIGIN_NO_COOKIES;
};

var can_play = function can_play(src) {
  return is_string(src) && SRC.test(src);
};

var extract_media_id = function extract_media_id(src) {
  var match = src ? src.match(SRC) : null;
  return match ? match[1] : null;
};

var build_embed_url = function build_embed_url(src, cookies) {
  var mediaId = extract_media_id(src);
  return mediaId ? "".concat(build_origin(cookies), "/embed/").concat(mediaId, "?enablejsapi=1") : null;
};

var fetch_poster = function fetch_poster(src) {
  var mediaId = extract_media_id(src);
  if (!mediaId) return Promise.resolve(null);

  var posterSrc = function posterSrc(quality) {
    return "https://i.ytimg.com/vi/".concat(mediaId, "/").concat(quality, ".jpg");
  }; // We are testing a that the image has a min-width of 121px because if the thumbnail does
  // not exist YouTube returns a blank/error image that is 120px wide.


  return load_image(posterSrc('maxresdefault'), 121) // 1080p (no padding)
  .catch(function () {
    return load_image(posterSrc('sddefault'), 121);
  }) // 640p (padded 4:3)
  .catch(function () {
    return load_image(posterSrc('hqdefault'), 121);
  }) // 480p (padded 4:3)
  .then(function (img) {
    return img.src || null;
  });
};

var YouTubeProvider = {
  name: NAME,
  decoder: DECODER,
  preconnections: PRECONNECTIONS,
  canPlay: can_play,
  buildOrigin: build_origin,
  extractMediaId: extract_media_id,
  buildEmbedURL: build_embed_url,
  onLoad: function onLoad(embed) {
    // Seems like we have to wait a random small delay or else YT player isn't ready.
    setTimeout(function () {
      return embed.postMessage({
        event: 'listening'
      });
    }, 100);
  },
  buildPostMessage: function buildPostMessage(command, args) {
    return {
      event: 'command',
      func: command,
      args: args || ''
    };
  },
  resolveReadyState: function resolveReadyState(data, ready) {
    var info = data.info,
        event = data.event;
    var playerState = info && info.playerState;
    if (event === 'error') ready.reject(info);
    if (playerState === 5) ready.resolve();
  },
  extractMediaTitle: function extractMediaTitle(data) {
    var videoData = data.info && data.info.videoData;
    var title = videoData && videoData.title;
    return title || null;
  }
};
var NAME$1 = 'Vimeo';
var ORIGIN$1 = 'https://www.vimeo.com';
var EMBED_ORIGIN = 'https://player.vimeo.com';
var SRC$1 = /vimeo(?:\.com|)\/([0-9]{9,})/;
var FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;
var THUMBNAIL_URL = /vimeocdn\.com\/video\/([0-9]+)/;
var BLANK_SRC_ID = '411655713';
var PRECONNECTIONS$1 = [ORIGIN$1, 'https://i.vimeocdn.com', 'https://f.vimeocdn.com', 'https://fresnel.vimeocdn.com'];
var DECODER$1 = decode_json;

var can_play$1 = function can_play$1(src) {
  return is_string(src) && !FILE_URL.test(src) && SRC$1.test(src);
};

var extract_media_id$1 = function extract_media_id$1(src) {
  var match = src ? src.match(SRC$1) : null;
  return match ? match[1] : null;
};

var build_embed_url$1 = function build_embed_url$1(src) {
  var mediaId = extract_media_id$1(src);
  return "".concat(EMBED_ORIGIN, "/video/").concat(mediaId || BLANK_SRC_ID);
};

var fetch_poster$1 = function fetch_poster$1(src) {
  var url = build_embed_url$1(src);
  if (!url) return Promise.resolve(null);
  return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
    return response.json();
  }).then(function (data) {
    var thumbnailId = data.thumbnail_url.match(THUMBNAIL_URL)[1];
    return "https://i.vimeocdn.com/video/".concat(thumbnailId, "_1920x1080.jpg");
  });
};

var VimeoProvider = {
  name: NAME$1,
  decoder: DECODER$1,
  preconnections: PRECONNECTIONS$1,
  canPlay: can_play$1,
  buildEmbedURL: build_embed_url$1,
  extractMediaId: extract_media_id$1,
  defaultParams: {
    transparent: false
  },
  onLoad: function onLoad() {},
  buildOrigin: function buildOrigin() {
    return EMBED_ORIGIN;
  },
  buildPostMessage: function buildPostMessage(command, args) {
    return {
      method: command,
      value: args || ''
    };
  },
  resolveReadyState: function resolveReadyState(data, ready, sendCommand) {
    var event = data.event,
        payload = data.data;

    if (event === 'error' && payload && payload.method === 'ready') {
      var error = new Error(payload.message);
      error.name = payload.name;
      ready.reject(error);
    }

    if (event === 'ready') sendCommand('addEventListener', 'loaded', true);

    if (event === 'loaded') {
      ready.resolve();
      sendCommand('getVideoTitle', [], true);
    }
  },
  extractMediaTitle: function extractMediaTitle(data) {
    if (data.method === 'getVideoTitle') return data.value;
    return null;
  }
};
var NAME$2 = 'Dailymotion';
var ORIGIN$2 = 'https://www.dailymotion.com';
var API_ENDPOINT = 'https://api.dailymotion.com';
var SRC$2 = /(?:dai\.ly|dailymotion|dailymotion\.com)\/(?:video\/|embed\/|)(?:video\/|)((?:\w)+)/;
var PRECONNECTIONS$2 = [ORIGIN$2, 'https://static1.dmcdn.net'];
var DECODER$2 = decode_query_string;

var can_play$2 = function can_play$2(src) {
  return is_string(src) && SRC$2.test(src);
};

var fetch_video_info_json = function fetch_video_info_json(mediaId, fields) {
  return window.fetch("".concat(API_ENDPOINT, "/video/").concat(mediaId, "?fields=").concat(fields)).then(function (response) {
    return response.json();
  });
};

var extract_media_id$2 = function extract_media_id$2(src) {
  var match = src ? src.match(SRC$2) : null;
  return match ? match[1] : null;
};

var fetch_video_duration = function fetch_video_duration(src) {
  var mediaId = extract_media_id$2(src);
  if (!mediaId) return Promise.resolve(null);
  return fetch_video_info_json(mediaId, 'duration').then(function (data) {
    return data.duration;
  });
};

var build_embed_url$2 = function build_embed_url$2(src) {
  var mediaId = extract_media_id$2(src);
  return mediaId ? "".concat(ORIGIN$2, "/embed/video/").concat(mediaId, "?api=1") : null;
};

var fetch_poster$2 = function fetch_poster$2(src) {
  var mediaId = extract_media_id$2(src);
  if (!mediaId) return Promise.resolve(null);
  return fetch_video_info_json(mediaId, 'thumbnail_1080_url').then(function (data) {
    return data.thumbnail_1080_url;
  });
};

var DailymotionProvider = {
  name: NAME$2,
  decoder: DECODER$2,
  preconnections: PRECONNECTIONS$2,
  canPlay: can_play$2,
  extractMediaId: extract_media_id$2,
  buildEmbedURL: build_embed_url$2,
  onLoad: function onLoad() {},
  buildOrigin: function buildOrigin() {
    return ORIGIN$2;
  },
  buildPostMessage: function buildPostMessage(command, args) {
    return {
      command: command,
      parameters: args || []
    };
  },
  resolveReadyState: function resolveReadyState(data, ready) {
    var event = data.event;
    if (event === 'playback_ready') ready.resolve();
    if (event === 'error') ready.reject(data);
  },
  extractMediaTitle: function extractMediaTitle(data) {
    var event = data.event;
    if (event === 'videochange') return data.title;
    return null;
  }
}; // @see https://github.com/videojs/video.js/blob/7.6.x/src/js/fullscreen-api.js

var FullscreenApi = {
  prefixed: true
};
var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror', 'fullscreen'], // WebKit
['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror', '-webkit-full-screen'], // Mozilla
['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror', '-moz-full-screen'], // Microsoft
['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError', '-ms-fullscreen']]; // eslint-disable-next-line func-names

function LoadFullscreenApi() {
  var specApi = apiMap[0];
  var browserApi; // Determine the supported set of functions.

  for (var i = 0; i < apiMap.length; i += 1) {
    // Check for exitFullscreen function.
    if (apiMap[i][1] in document) {
      browserApi = apiMap[i];
      break;
    }
  } // Map the browser API names to the spec API names.


  if (browserApi) {
    for (var _i3 = 0; _i3 < browserApi.length; _i3 += 1) {
      FullscreenApi[specApi[_i3]] = browserApi[_i3];
    }

    FullscreenApi.prefixed = browserApi[0] !== specApi[0];
  }

  return FullscreenApi;
}
/* src/StandardPlayer.svelte generated by Svelte v3.24.0 */


function create_default_slot$2(ctx) {
  var switch_instance;
  var switch_instance_anchor;
  var current;
  var switch_instance_spread_levels = [
  /*props*/
  ctx[2], {
    src:
    /*$src*/
    ctx[5]
  }, {
    config:
    /*$providerConfig*/
    ctx[9]
  }, {
    version:
    /*$providerVersion*/
    ctx[10]
  }];
  var switch_value =
  /*$Provider*/
  ctx[6] &&
  /*$Provider*/
  ctx[6].default;

  function switch_props(ctx) {
    var switch_instance_props = {};

    for (var i = 0; i < switch_instance_spread_levels.length; i += 1) {
      switch_instance_props = assign(switch_instance_props, switch_instance_spread_levels[i]);
    }

    return {
      props: switch_instance_props
    };
  }

  if (switch_value) {
    switch_instance = new switch_value(switch_props());
    /*switch_instance_binding*/

    ctx[65](switch_instance);
    switch_instance.$on("update",
    /*onUpdate*/
    ctx[57]);
    switch_instance.$on("error",
    /*error_handler*/
    ctx[66]);
  }

  return {
    c: function c() {
      if (switch_instance) create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m: function m(target, anchor) {
      if (switch_instance) {
        mount_component(switch_instance, target, anchor);
      }

      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var switch_instance_changes = dirty[0] &
      /*props, $src, $providerConfig, $providerVersion*/
      1572 ? get_spread_update(switch_instance_spread_levels, [dirty[0] &
      /*props*/
      4 && get_spread_object(
      /*props*/
      ctx[2]), dirty[0] &
      /*$src*/
      32 && {
        src:
        /*$src*/
        ctx[5]
      }, dirty[0] &
      /*$providerConfig*/
      512 && {
        config:
        /*$providerConfig*/
        ctx[9]
      }, dirty[0] &
      /*$providerVersion*/
      1024 && {
        version:
        /*$providerVersion*/
        ctx[10]
      }]) : {};

      if (switch_value !== (switch_value =
      /*$Provider*/
      ctx[6] &&
      /*$Provider*/
      ctx[6].default)) {
        if (switch_instance) {
          group_outros();
          var old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, function () {
            destroy_component(old_component, 1);
          });
          check_outros();
        }

        if (switch_value) {
          switch_instance = new switch_value(switch_props());
          /*switch_instance_binding*/

          ctx[65](switch_instance);
          switch_instance.$on("update",
          /*onUpdate*/
          ctx[57]);
          switch_instance.$on("error",
          /*error_handler*/
          ctx[66]);
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        switch_instance.$set(switch_instance_changes);
      }
    },
    i: function i(local) {
      if (current) return;
      if (switch_instance) transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      if (switch_instance) transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*switch_instance_binding*/
      ctx[65](null);
      if (detaching) detach(switch_instance_anchor);
      if (switch_instance) destroy_component(switch_instance, detaching);
    }
  };
}

function create_fragment$4(ctx) {
  var playerwrapper;
  var current;
  playerwrapper = new PlayerWrapper({
    props: {
      isEnabled:
      /*hasWrapper*/
      ctx[0],
      aspectRatio:
      /*$isVideoView*/
      ctx[8] && !
      /*$isFullscreenActive*/
      ctx[4] ?
      /*$aspectRatio*/
      ctx[7] : null,
      $$slots: {
        default: [create_default_slot$2]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  playerwrapper.$on("mount",
  /*mount_handler*/
  ctx[67]);
  return {
    c: function c() {
      create_component(playerwrapper.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(playerwrapper, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var playerwrapper_changes = {};
      if (dirty[0] &
      /*hasWrapper*/
      1) playerwrapper_changes.isEnabled =
      /*hasWrapper*/
      ctx[0];
      if (dirty[0] &
      /*$isVideoView, $isFullscreenActive, $aspectRatio*/
      400) playerwrapper_changes.aspectRatio =
      /*$isVideoView*/
      ctx[8] && !
      /*$isFullscreenActive*/
      ctx[4] ?
      /*$aspectRatio*/
      ctx[7] : null;

      if (dirty[0] &
      /*$Provider, props, $src, $providerConfig, $providerVersion, $provider*/
      1644 | dirty[4] &
      /*$$scope*/
      1073741824) {
        playerwrapper_changes.$$scope = {
          dirty: dirty,
          ctx: ctx
        };
      }

      playerwrapper.$set(playerwrapper_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(playerwrapper.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(playerwrapper.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(playerwrapper, detaching);
    }
  };
}

var NO_PIP_SUPPORT_ERROR_MSG = "Provider does not support PiP.";
var VIDEO_NOT_READY_ERROR_MSG = "Action not supported, must be a video that is ready for playback.";
var FULLSCREEN_NOT_SUPPORTED_ERROR_MSG = "Fullscreen not supported.";

function instance$4($$self, $$props, $$invalidate) {
  var $currentPlayer;
  var $isPlayerActive;
  var $playbackReady;
  var $canMutedAutoplay;
  var $playsinline;
  var $playbackEnded;
  var $internalTime;
  var $currentTime;
  var $provider;
  var $paused;
  var $seeking;
  var $canInteract;
  var $buffered;
  var $playbackStarted;
  var $buffering;
  var $duration;
  var $autoplay;
  var $rebuilding;
  var $canAutoplay;
  var $muted;
  var $isFullscreenActive;
  var $autopause;
  var $playing;
  var $volume;
  var $useNativeCaptions;
  var $tracks;
  var $currentTrackIndex;
  var $isPiPActive;
  var $src;
  var $Provider;
  var $canSetPoster;
  var $useNativeControls;
  var $poster;
  var $aspectRatio;
  var $useNativeView;
  var $isControlsEnabled;
  var $canSetPlaybackRate;
  var $playbackRate;
  var $canSetVideoQuality;
  var $videoQuality;
  var $canSetTracks;
  var $canSetTrack;
  var $isVideoReady;
  var $canSetPiP;
  var $isVideoView;
  var $providerConfig;
  var $providerVersion;
  component_subscribe($$self, currentPlayer, function ($$value) {
    return $$invalidate(80, $currentPlayer = $$value);
  });
  var self = get_current_component();

  var _$$props = $$props,
      _$$props$_standardSto = _$$props._standardStore,
      _standardStore = _$$props$_standardSto === void 0 ? null : _$$props$_standardSto;

  var onPropsChange = noop;

  if (is_null(_standardStore)) {
    _standardStore = buildStandardStore(self);
    var _standardStore2 = _standardStore;
    onPropsChange = _standardStore2.onPropsChange;
  }

  var _standardStore3 = _standardStore,
      store = _standardStore3.store,
      resetStore = _standardStore3.resetStore;
  var playsinline = store.playsinline,
      paused = store.paused,
      muted = store.muted,
      playbackEnded = store.playbackEnded,
      volume = store.volume,
      seeking = store.seeking,
      internalTime = store.internalTime,
      currentTime = store.currentTime,
      isPiPActive = store.isPiPActive,
      playbackRate = store.playbackRate,
      videoQuality = store.videoQuality,
      src = store.src,
      isControlsEnabled = store.isControlsEnabled,
      aspectRatio = store.aspectRatio,
      buffering = store.buffering,
      buffered = store.buffered,
      autopause = store.autopause,
      autoplay = store.autoplay,
      playing = store.playing,
      playbackStarted = store.playbackStarted,
      poster = store.poster,
      playbackReady = store.playbackReady,
      isVideoView = store.isVideoView,
      tracks = store.tracks,
      currentTrackIndex = store.currentTrackIndex,
      provider = store.provider,
      rebuilding = store.rebuilding,
      isVideoReady = store.isVideoReady,
      canInteract = store.canInteract,
      isFullscreenActive = store.isFullscreenActive,
      useNativeView = store.useNativeView,
      useNativeControls = store.useNativeControls,
      useNativeCaptions = store.useNativeCaptions,
      duration = store.duration,
      Provider = store.Provider,
      isPlayerActive = store.isPlayerActive,
      providerConfig = store.providerConfig,
      providerVersion = store.providerVersion;
  component_subscribe($$self, playsinline, function (value) {
    return $$invalidate(84, $playsinline = value);
  });
  component_subscribe($$self, paused, function (value) {
    return $$invalidate(88, $paused = value);
  });
  component_subscribe($$self, muted, function (value) {
    return $$invalidate(98, $muted = value);
  });
  component_subscribe($$self, playbackEnded, function (value) {
    return $$invalidate(85, $playbackEnded = value);
  });
  component_subscribe($$self, volume, function (value) {
    return $$invalidate(101, $volume = value);
  });
  component_subscribe($$self, seeking, function (value) {
    return $$invalidate(89, $seeking = value);
  });
  component_subscribe($$self, internalTime, function (value) {
    return $$invalidate(86, $internalTime = value);
  });
  component_subscribe($$self, currentTime, function (value) {
    return $$invalidate(87, $currentTime = value);
  });
  component_subscribe($$self, isPiPActive, function (value) {
    return $$invalidate(105, $isPiPActive = value);
  });
  component_subscribe($$self, playbackRate, function (value) {
    return $$invalidate(112, $playbackRate = value);
  });
  component_subscribe($$self, videoQuality, function (value) {
    return $$invalidate(114, $videoQuality = value);
  });
  component_subscribe($$self, src, function (value) {
    return $$invalidate(5, $src = value);
  });
  component_subscribe($$self, isControlsEnabled, function (value) {
    return $$invalidate(110, $isControlsEnabled = value);
  });
  component_subscribe($$self, aspectRatio, function (value) {
    return $$invalidate(7, $aspectRatio = value);
  });
  component_subscribe($$self, buffering, function (value) {
    return $$invalidate(93, $buffering = value);
  });
  component_subscribe($$self, buffered, function (value) {
    return $$invalidate(91, $buffered = value);
  });
  component_subscribe($$self, autopause, function (value) {
    return $$invalidate(99, $autopause = value);
  });
  component_subscribe($$self, autoplay, function (value) {
    return $$invalidate(95, $autoplay = value);
  });
  component_subscribe($$self, playing, function (value) {
    return $$invalidate(100, $playing = value);
  });
  component_subscribe($$self, playbackStarted, function (value) {
    return $$invalidate(92, $playbackStarted = value);
  });
  component_subscribe($$self, poster, function (value) {
    return $$invalidate(108, $poster = value);
  });
  component_subscribe($$self, playbackReady, function (value) {
    return $$invalidate(82, $playbackReady = value);
  });
  component_subscribe($$self, isVideoView, function (value) {
    return $$invalidate(8, $isVideoView = value);
  });
  component_subscribe($$self, tracks, function (value) {
    return $$invalidate(103, $tracks = value);
  });
  component_subscribe($$self, currentTrackIndex, function (value) {
    return $$invalidate(104, $currentTrackIndex = value);
  });
  component_subscribe($$self, provider, function (value) {
    return $$invalidate(3, $provider = value);
  });
  component_subscribe($$self, rebuilding, function (value) {
    return $$invalidate(96, $rebuilding = value);
  });
  component_subscribe($$self, isVideoReady, function (value) {
    return $$invalidate(117, $isVideoReady = value);
  });
  component_subscribe($$self, canInteract, function (value) {
    return $$invalidate(90, $canInteract = value);
  });
  component_subscribe($$self, isFullscreenActive, function (value) {
    return $$invalidate(4, $isFullscreenActive = value);
  });
  component_subscribe($$self, useNativeView, function (value) {
    return $$invalidate(109, $useNativeView = value);
  });
  component_subscribe($$self, useNativeControls, function (value) {
    return $$invalidate(107, $useNativeControls = value);
  });
  component_subscribe($$self, useNativeCaptions, function (value) {
    return $$invalidate(102, $useNativeCaptions = value);
  });
  component_subscribe($$self, duration, function (value) {
    return $$invalidate(94, $duration = value);
  });
  component_subscribe($$self, Provider, function (value) {
    return $$invalidate(6, $Provider = value);
  });
  component_subscribe($$self, isPlayerActive, function (value) {
    return $$invalidate(81, $isPlayerActive = value);
  });
  component_subscribe($$self, providerConfig, function (value) {
    return $$invalidate(9, $providerConfig = value);
  });
  component_subscribe($$self, providerVersion, function (value) {
    return $$invalidate(10, $providerVersion = value);
  });
  var canSetPiP = store.canSetPiP,
      canSetTracks = store.canSetTracks,
      canSetTrack = store.canSetTrack,
      canAutoplay = store.canAutoplay,
      canMutedAutoplay = store.canMutedAutoplay,
      canSetPoster = store.canSetPoster,
      canSetPlaybackRate = store.canSetPlaybackRate,
      canSetVideoQuality = store.canSetVideoQuality;
  component_subscribe($$self, canSetPiP, function (value) {
    return $$invalidate(118, $canSetPiP = value);
  });
  component_subscribe($$self, canSetTracks, function (value) {
    return $$invalidate(115, $canSetTracks = value);
  });
  component_subscribe($$self, canSetTrack, function (value) {
    return $$invalidate(116, $canSetTrack = value);
  });
  component_subscribe($$self, canAutoplay, function (value) {
    return $$invalidate(97, $canAutoplay = value);
  });
  component_subscribe($$self, canMutedAutoplay, function (value) {
    return $$invalidate(83, $canMutedAutoplay = value);
  });
  component_subscribe($$self, canSetPoster, function (value) {
    return $$invalidate(106, $canSetPoster = value);
  });
  component_subscribe($$self, canSetPlaybackRate, function (value) {
    return $$invalidate(111, $canSetPlaybackRate = value);
  });
  component_subscribe($$self, canSetVideoQuality, function (value) {
    return $$invalidate(113, $canSetVideoQuality = value);
  });
  var playerWrapper;
  var _$$props2 = $$props,
      _$$props2$parentEl = _$$props2.parentEl,
      parentEl = _$$props2$parentEl === void 0 ? null : _$$props2$parentEl;
  var _$$props3 = $$props,
      _$$props3$hasWrapper = _$$props3.hasWrapper,
      hasWrapper = _$$props3$hasWrapper === void 0 ? true : _$$props3$hasWrapper;

  var tick$1 = function tick$1() {
    return tick();
  }; // Filter out any player props before passing them to the provider.


  var props = {};
  onDestroy(function () {
    if ($currentPlayer === self) set_store_value(currentPlayer, $currentPlayer = null);
    $$invalidate(68, self = null);
  });
  if (is_null($currentPlayer)) set_store_value(currentPlayer, $currentPlayer = self); // --------------------------------------------------------------
  // Provider Events
  // --------------------------------------------------------------
  // Temporary states used to normalize player differences.

  var tempMute = false;
  var tempPlay = false;
  var tempPause = false;
  var tempControls = false;
  var updatingVolume = false;
  var updatingTime = false;

  var cancelTempAction = /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cb) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return tick();

            case 2:
              setTimeout(function () {
                cb();
              }, 100);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function cancelTempAction(_x5) {
      return _ref39.apply(this, arguments);
    };
  }();

  var initiateTempPlayback = function initiateTempPlayback() {
    if (!$playbackReady || !$canMutedAutoplay) return;
    $$invalidate(70, tempMute = true);
    $$invalidate(71, tempPlay = true);
    set_store_value(playsinline, $playsinline = true);
  };

  var onRestart = function onRestart() {
    if (get_store_value(store.live) || !$playbackEnded) return;
    set_store_value(internalTime, $internalTime = 0);
    set_store_value(currentTime, $currentTime = 0);
    set_store_value(playbackEnded, $playbackEnded = false);
    $provider.setCurrentTime(0);
    set_store_value(paused, $paused = false);
  };

  var onTimeUpdate = function onTimeUpdate(time) {
    if ($seeking || updatingTime || !$canInteract) return;
    set_store_value(internalTime, $internalTime = time);
    set_store_value(currentTime, $currentTime = time);
    if ($internalTime === 0 && $playbackEnded) onRestart();
  };

  afterUpdate(function () {
    if (!$playbackReady || $seeking || $currentTime === $internalTime) return;
    set_store_value(internalTime, $internalTime = $currentTime);
    $provider.setCurrentTime($currentTime);
    updatingTime = true;
  });

  var checkIfBuffering = function checkIfBuffering() {
    if ($buffered < $currentTime || $playbackStarted && $buffered === 0) {
      set_store_value(buffering, $buffering = true);
    }
  };

  var checkHasSeeked = function checkHasSeeked() {
    if (!$seeking || $buffered <= $currentTime && $currentTime < $duration) return;
    set_store_value(seeking, $seeking = false);
    set_store_value(buffering, $buffering = false);
    updatingTime = false;

    if (!$playbackStarted) {
      set_store_value(playbackStarted, $playbackStarted = true);
      if ($currentTime === $duration) set_store_value(currentTime, $currentTime = 0);
    }

    if ($playbackEnded) set_store_value(playbackEnded, $playbackEnded = false);
    cancelTempAction(function () {
      $$invalidate(72, tempPause = false);
    });
  };

  var onAutoplay = function onAutoplay() {
    if (!$autoplay || $rebuilding || $currentTime > 0 || !$canAutoplay || !$canMutedAutoplay) return;
    set_store_value(paused, $paused = false);
    set_store_value(playsinline, $playsinline = true);
    if (!$canAutoplay) set_store_value(muted, $muted = true);
  };

  var onRebuildStart = function onRebuildStart() {
    if (!$playbackReady) return;
    set_store_value(rebuilding, $rebuilding = true);
    set_store_value(buffering, $buffering = true);
  };

  var onRebuildEnd = /*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!$playbackReady || !$rebuilding)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              if ($currentTime > 0) $provider.setCurrentTime($currentTime);
              _context4.next = 5;
              return tick();

            case 5:
              set_store_value(rebuilding, $rebuilding = false); // eslint-disable-next-line no-use-before-define

              if ($isFullscreenActive) requestFullscreen().catch(noop);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onRebuildEnd() {
      return _ref40.apply(this, arguments);
    };
  }();

  var onRebuild = /*#__PURE__*/function () {
    var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if ($playbackReady) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              // Cancel any existing temp states as rebuild may be called multiple times.
              $$invalidate(70, tempMute = false);
              $$invalidate(71, tempPlay = false);
              _context5.next = 6;
              return tick();

            case 6:
              if (!($currentTime > 0 && $canMutedAutoplay)) {
                _context5.next = 9;
                break;
              }

              initiateTempPlayback();
              return _context5.abrupt("return");

            case 9:
              onRebuildEnd();

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function onRebuild() {
      return _ref41.apply(this, arguments);
    };
  }();

  var onPlaybackReady = /*#__PURE__*/function () {
    var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return tick();

            case 2:
              set_store_value(playbackReady, $playbackReady = true);
              set_store_value(buffering, $buffering = false);
              onRebuild();

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function onPlaybackReady() {
      return _ref42.apply(this, arguments);
    };
  }();

  var onAutopause = function onAutopause() {
    if (!$autopause || !$currentPlayer || $currentPlayer === self) return;
    set_store_value(currentPlayer, $currentPlayer.paused = true, $currentPlayer);
  }; // If a provider fires a `pause` event before `seeking` we cancel it to not mess
  // with our internal paused state.


  var firePauseTimer;

  var onPause = function onPause() {
    firePauseTimer = window.setTimeout(function () {
      if (tempPause) return;
      set_store_value(paused, $paused = true);
      set_store_value(buffering, $buffering = false);
      set_store_value(playing, $playing = false);
    }, 100);
  };

  var onVolumeChange = function onVolumeChange(newVolume) {
    set_store_value(volume, $volume = newVolume);
    $$invalidate(74, updatingVolume = true);
  };

  var onBuffered = function onBuffered(progress) {
    if (progress) set_store_value(buffered, $buffered = progress);
    if ($seeking) checkHasSeeked();
  };

  var onSeeking = function onSeeking() {
    if ($seeking) return;
    window.clearTimeout(firePauseTimer);
    set_store_value(seeking, $seeking = true);
    checkIfBuffering();
    !$playbackStarted ? initiateTempPlayback() : $$invalidate(72, tempPause = true);
  };

  var onSeeked = /*#__PURE__*/function () {
    var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if ($seeking) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              _context7.next = 4;
              return tick();

            case 4:
              onBuffered($buffered);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function onSeeked() {
      return _ref43.apply(this, arguments);
    };
  }();

  var onPlay = function onPlay() {
    set_store_value(paused, $paused = false);
    checkIfBuffering();
  };

  var onPlaying = function onPlaying() {
    set_store_value(buffering, $buffering = false);
    set_store_value(playbackStarted, $playbackStarted = true);
    onSeeked();
    onAutopause();
    set_store_value(currentPlayer, $currentPlayer = self);

    if (!tempPlay) {
      set_store_value(paused, $paused = false);
      set_store_value(playing, $playing = true);
    }

    $provider.setPaused($paused);
    $provider.setMuted($muted);
    cancelTempAction(function () {
      $$invalidate(71, tempPlay = false);
      $$invalidate(70, tempMute = false);
    });
    onRebuildEnd();
  };

  var onLoop = /*#__PURE__*/function () {
    var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(get_store_value(store.live) || !get_store_value(store.loop))) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt("return");

            case 2:
              _context8.next = 4;
              return tick();

            case 4:
              onRestart();

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function onLoop() {
      return _ref44.apply(this, arguments);
    };
  }();

  var onPlaybackEnd = function onPlaybackEnd() {
    set_store_value(playbackEnded, $playbackEnded = true);
    set_store_value(paused, $paused = true);
    onLoop();
  };

  var onStateChange = /*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(state) {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return tick();

            case 2:
              _context9.t0 = state;
              _context9.next = _context9.t0 === PlayerState.CUED ? 5 : _context9.t0 === PlayerState.PAUSED ? 7 : _context9.t0 === PlayerState.BUFFERING ? 11 : _context9.t0 === PlayerState.PLAYING ? 13 : _context9.t0 === PlayerState.ENDED ? 15 : 17;
              break;

            case 5:
              onPlaybackReady();
              return _context9.abrupt("break", 17);

            case 7:
              if (!$rebuilding) {
                _context9.next = 9;
                break;
              }

              return _context9.abrupt("return");

            case 9:
              onPause();
              return _context9.abrupt("break", 17);

            case 11:
              set_store_value(buffering, $buffering = true);
              return _context9.abrupt("break", 17);

            case 13:
              onPlaying();
              return _context9.abrupt("break", 17);

            case 15:
              onPlaybackEnd();
              return _context9.abrupt("break", 17);

            case 17:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function onStateChange(_x6) {
      return _ref45.apply(this, arguments);
    };
  }(); // TODO: this is basically a crappy reducer.


  var onUpdate = function onUpdate(e) {
    var info = e.detail;
    if (info.state) onStateChange(info.state);
    if (info.play && !tempPlay) onPlay();
    if (info.rebuild) onRebuildStart();
    if ($rebuilding) return;
    if (is_null(info.poster) || info.poster) store.nativePoster.set(info.poster);
    if (is_boolean(info.isLive)) store.isLive.set(info.isLive);
    if (is_number(info.duration)) set_store_value(duration, $duration = parseFloat(info.duration));
    if (is_number(info.currentTime)) onTimeUpdate(parseFloat(info.currentTime));
    if (is_number(info.buffered)) onBuffered(parseFloat(info.buffered));
    if (info.seeking) onSeeking();
    if (info.seeked) onSeeked();
    if (is_number(info.mediaType)) store.mediaType.set(info.mediaType);
    if (info.title) store.title.set(info.title);
    if (info.currentSrc) store.currentSrc.set(info.currentSrc);
    if (info.mediaId) store.mediaId.set(info.mediaId);
    if (is_number(info.volume)) onVolumeChange(parseInt(info.volume, 10));
    if (is_boolean(info.muted) && !tempMute) set_store_value(muted, $muted = info.muted);
    if (info.origin) store.origin.set(info.origin);
    if (is_number(info.videoQuality)) store.videoQuality.forceSet(info.videoQuality);
    if (info.videoQualities) store.videoQualities.set(info.videoQualities);
    if (info.playbackRate) store.playbackRate.forceSet(info.playbackRate);
    if (info.playbackRates) store.playbackRates.set(info.playbackRates);

    if ($useNativeCaptions) {
      if (info.tracks) set_store_value(tracks, $tracks = info.tracks);
      if (is_number(info.currentTrackIndex)) set_store_value(currentTrackIndex, $currentTrackIndex = info.currentTrackIndex);
    }

    if (is_boolean(info.pip)) set_store_value(isPiPActive, $isPiPActive = info.pip); // eslint-disable-next-line no-use-before-define

    if (is_boolean(info.fullscreen)) onFullscreenChange(info.fullscreen);
  };

  var onSrcChange = function onSrcChange() {
    resetStore(); // TODO: what if provider can't play the src? Need to stop buffering.

    if ($src && $Provider) set_store_value(buffering, $buffering = true);
    updatingTime = false;
    $$invalidate(71, tempPlay = false);
    $$invalidate(71, tempPlay = false);
    $$invalidate(70, tempMute = false);
    $$invalidate(73, tempControls = false);
  };

  var onProviderChange = function onProviderChange() {
    onSrcChange();
    store.origin.set(null);
    store.isPiPActive.set(false); // eslint-disable-next-line no-use-before-define

    if ($isFullscreenActive) exitFullscreen().catch(noop);
    if (!$Provider) store.mediaType.set(MediaType.NONE);
  };

  var pipRequest = function pipRequest(active) {
    if (!$isVideoReady) {
      return Promise.reject(VIDEO_NOT_READY_ERROR_MSG);
    }

    if (!$canSetPiP) {
      return Promise.reject(NO_PIP_SUPPORT_ERROR_MSG);
    }

    return Promise.resolve($provider.setPiP(active));
  };

  var requestPiP = function requestPiP() {
    return pipRequest(true);
  };

  var exitPiP = function exitPiP() {
    return pipRequest(false);
  };

  var fsDispose = [];
  var fullscreenApi = null;
  var doesDocumentSupportFullscreenApi = false;

  var isFullscreen = function isFullscreen() {
    var els = [playerWrapper, parentEl, $provider && $provider.getEl()].filter(Boolean);
    var isActive = els.includes(document[fullscreenApi.fullscreenElement]);
    if (!isActive) isActive = els.some(function (el) {
      return el.matches && el.matches(":".concat(fullscreenApi.fullscreen));
    });
    return isActive;
  };

  var onDocumentFullscreenChange = function onDocumentFullscreenChange() {
    set_store_value(isFullscreenActive, $isFullscreenActive = isFullscreen());
  };

  var onFullscreenChange = function onFullscreenChange(isActive) {
    set_store_value(isFullscreenActive, $isFullscreenActive = isActive);
    if (!$isFullscreenActive) $$invalidate(73, tempControls = false);
    $$invalidate(72, tempPause = false); // iOS pauses the video when exiting fullscreen.

    if (!$paused) {
      setTimeout(function () {
        $provider.setPaused(false);
      }, 300);
    }
  };

  var requestDocumentFullscreen = function requestDocumentFullscreen(shouldEnter) {
    var el = parentEl || playerWrapper;
    if (!el || !shouldEnter && !isFullscreen()) return Promise.reject();
    if (shouldEnter && isFullscreen()) return Promise.resolve();
    var request = shouldEnter ? el[fullscreenApi.requestFullscreen]() : document[fullscreenApi.exitFullscreen]();
    return Promise.resolve(request);
  }; // TODO: the two providers which can set fullscreen at the moment (File/Dailymotion) don't
  // require a rebuild when enabling controls, if at some point a provider does this won't work.


  var requestProviderFullscreen = function requestProviderFullscreen(shouldEnter) {
    if (shouldEnter) $$invalidate(73, tempControls = true);
    $$invalidate(72, tempPause = true);
    return Promise.resolve($provider.setFullscreen(shouldEnter));
  };

  var fullscreenRequest = function fullscreenRequest(shouldEnter) {
    if (!$isVideoReady) {
      return Promise.reject(VIDEO_NOT_READY_ERROR_MSG);
    }

    if (doesDocumentSupportFullscreenApi) {
      return requestDocumentFullscreen(shouldEnter);
    }

    if (canProviderFullscreen) {
      return requestProviderFullscreen(shouldEnter);
    }

    return Promise.reject(FULLSCREEN_NOT_SUPPORTED_ERROR_MSG);
  };

  var requestFullscreen = function requestFullscreen() {
    return fullscreenRequest(true);
  };

  var exitFullscreen = function exitFullscreen() {
    return fullscreenRequest(false);
  };

  onMount(function () {
    fullscreenApi = LoadFullscreenApi();
    $$invalidate(79, doesDocumentSupportFullscreenApi = !!fullscreenApi.requestFullscreen);
    if (!doesDocumentSupportFullscreenApi) return;
    fsDispose.push(listen(document, fullscreenApi.fullscreenchange, onDocumentFullscreenChange));
    /* *
    * We have to listen to this on webkit, because no `fullscreenchange` event is fired when the
    * video element enters or exits fullscreen by:
    *
    *  1. The native Html5 fullscreen video control.
    *  2. Calling requestFullscreen from the video element directly.
    *  3. Calling requestFullscreen inside an iframe.
    * */

    if (document.webkitExitFullscreen) {
      fsDispose.push(listen(document, "webkitfullscreenchange", onDocumentFullscreenChange));
    }
  });
  onDestroy(function () {
    run_all(fsDispose);
    fsDispose = [];
  });

  function switch_instance_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $provider = $$value;
      provider.set($provider);
    });
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  var mount_handler = function mount_handler(e) {
    $$invalidate(1, playerWrapper = e.detail);
  };

  $$self.$set = function ($$new_props) {
    $$invalidate(153, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
    if ("_standardStore" in $$new_props) $$invalidate(58, _standardStore = $$new_props._standardStore);
    if ("parentEl" in $$new_props) $$invalidate(59, parentEl = $$new_props.parentEl);
    if ("hasWrapper" in $$new_props) $$invalidate(0, hasWrapper = $$new_props.hasWrapper);
  };

  var canProviderFullscreen;

  $$self.$$.update = function () {
    onPropsChange($$props);
    Object.keys($$props).filter(function (prop) {
      return !store[prop];
    }).forEach(function (prop) {
      $$invalidate(2, props[prop] = $$props[prop], props);
    });

    if ($$self.$$.dirty[2] &
    /*$currentPlayer, self*/
    262208) {
      set_store_value(isPlayerActive, $isPlayerActive = $currentPlayer === self);
    }

    if ($$self.$$.dirty[0] &
    /*$src*/
    32) {
      onSrcChange();
    }

    if ($$self.$$.dirty[0] &
    /*$Provider*/
    64) {
      onProviderChange();
    }

    if ($$self.$$.dirty[2] &
    /*$playbackReady*/
    1048576 | $$self.$$.dirty[3] &
    /*$autoplay*/
    4) {
      // --------------------------------------------------------------
      // State Updates
      // --------------------------------------------------------------
      if ($autoplay && $playbackReady) onAutoplay();
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$playsinline*/
    4194304 | $$self.$$.dirty[3] &
    /*$rebuilding*/
    8) {
      if ($provider && !$rebuilding) $provider.setPlaysinline($playsinline);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[3] &
    /*$canSetPoster, $rebuilding, $useNativeControls, $poster*/
    57352) {
      if ($canSetPoster && !$rebuilding) $provider.setPoster($useNativeControls ? $poster : null);
    }

    if ($$self.$$.dirty[0] &
    /*$provider, $aspectRatio*/
    136) {
      if ($provider && is_function$1($provider.setAspectRatio)) $provider.setAspectRatio($aspectRatio);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[3] &
    /*$rebuilding, $useNativeView*/
    65544) {
      if ($provider && !$rebuilding && is_function$1($provider.setView)) {
        $provider.setView($useNativeView);
      }
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*tempControls*/
    2048 | $$self.$$.dirty[3] &
    /*$rebuilding, $isControlsEnabled, $useNativeControls*/
    147464) {
      if ($provider && !$rebuilding) {
        $provider.setControls($isControlsEnabled && ($useNativeControls || tempControls));
      }
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$paused, $playbackEnded*/
    75497472) {
      if ($provider && !$paused && $playbackEnded) onRestart();
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$playbackReady, $paused, tempPause, tempPlay*/
    68158976) {
      if ($provider && $playbackReady) $provider.setPaused(($paused || tempPause) && !tempPlay);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract, tempMute*/
    268435712 | $$self.$$.dirty[3] &
    /*$muted*/
    32) {
      if ($provider && $canInteract) $provider.setMuted($muted || tempMute);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract*/
    268435456 | $$self.$$.dirty[3] &
    /*$canSetPlaybackRate, $playbackRate*/
    786432) {
      if ($canSetPlaybackRate && $canInteract) $provider.setPlaybackRate($playbackRate);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract*/
    268435456 | $$self.$$.dirty[3] &
    /*$canSetVideoQuality, $videoQuality*/
    3145728) {
      if ($canSetVideoQuality && $canInteract) $provider.setVideoQuality($videoQuality);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract, updatingVolume*/
    268439552 | $$self.$$.dirty[3] &
    /*$volume*/
    256) {
      $provider && $canInteract && !updatingVolume ? $provider.setVolume($volume) : $$invalidate(74, updatingVolume = false);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract*/
    268435456 | $$self.$$.dirty[3] &
    /*$canSetTracks, $useNativeCaptions, $tracks*/
    4195840) {
      // --------------------------------------------------------------
      // Tracks
      // --------------------------------------------------------------
      if ($canSetTracks && $canInteract) $provider.setTracks($useNativeCaptions ? $tracks : []);
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8 | $$self.$$.dirty[2] &
    /*$canInteract*/
    268435456 | $$self.$$.dirty[3] &
    /*$canSetTrack, $useNativeCaptions, $currentTrackIndex*/
    8391168) {
      if ($canSetTrack && $canInteract) {
        $provider.setTrack($useNativeCaptions ? $currentTrackIndex : -1);
      }
    }

    if ($$self.$$.dirty[0] &
    /*$provider*/
    8) {
      $$invalidate(119, canProviderFullscreen = $provider && $provider.supportsFullscreen() && is_function$1($provider.setFullscreen));
    }

    if ($$self.$$.dirty[2] &
    /*doesDocumentSupportFullscreenApi*/
    131072 | $$self.$$.dirty[3] &
    /*$isVideoReady, canProviderFullscreen*/
    83886080) {
      store.canSetFullscreen.set($isVideoReady && (doesDocumentSupportFullscreenApi || canProviderFullscreen));
    }
  };

  $$props = exclude_internal_props($$props);
  return [hasWrapper, playerWrapper, props, $provider, $isFullscreenActive, $src, $Provider, $aspectRatio, $isVideoView, $providerConfig, $providerVersion, playsinline, paused, muted, playbackEnded, volume, seeking, internalTime, currentTime, isPiPActive, playbackRate, videoQuality, src, isControlsEnabled, aspectRatio, buffering, buffered, autopause, autoplay, playing, playbackStarted, poster, playbackReady, isVideoView, tracks, currentTrackIndex, provider, rebuilding, isVideoReady, canInteract, isFullscreenActive, useNativeView, useNativeControls, useNativeCaptions, duration, Provider, isPlayerActive, providerConfig, providerVersion, canSetPiP, canSetTracks, canSetTrack, canAutoplay, canMutedAutoplay, canSetPoster, canSetPlaybackRate, canSetVideoQuality, onUpdate, _standardStore, parentEl, tick$1, requestPiP, exitPiP, requestFullscreen, exitFullscreen, switch_instance_binding, error_handler, mount_handler];
}

var StandardPlayer = /*#__PURE__*/function (_SvelteComponent5) {
  _inherits(StandardPlayer, _SvelteComponent5);

  var _super5 = _createSuper(StandardPlayer);

  function StandardPlayer(options) {
    var _this5;

    _classCallCheck(this, StandardPlayer);

    _this5 = _super5.call(this);
    init(_assertThisInitialized(_this5), options, instance$4, create_fragment$4, safe_not_equal, {
      _standardStore: 58,
      parentEl: 59,
      hasWrapper: 0,
      tick: 60,
      requestPiP: 61,
      exitPiP: 62,
      requestFullscreen: 63,
      exitFullscreen: 64
    }, [-1, -1, -1, -1, -1]);
    return _this5;
  }

  _createClass(StandardPlayer, [{
    key: "_standardStore",
    get: function get() {
      return this.$$.ctx[58];
    },
    set: function set(_standardStore) {
      this.$set({
        _standardStore: _standardStore
      });
      flush();
    }
  }, {
    key: "parentEl",
    get: function get() {
      return this.$$.ctx[59];
    },
    set: function set(parentEl) {
      this.$set({
        parentEl: parentEl
      });
      flush();
    }
  }, {
    key: "hasWrapper",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(hasWrapper) {
      this.$set({
        hasWrapper: hasWrapper
      });
      flush();
    }
  }, {
    key: "tick",
    get: function get() {
      return this.$$.ctx[60];
    }
  }, {
    key: "requestPiP",
    get: function get() {
      return this.$$.ctx[61];
    }
  }, {
    key: "exitPiP",
    get: function get() {
      return this.$$.ctx[62];
    }
  }, {
    key: "requestFullscreen",
    get: function get() {
      return this.$$.ctx[63];
    }
  }, {
    key: "exitFullscreen",
    get: function get() {
      return this.$$.ctx[64];
    }
  }]);

  return StandardPlayer;
}(SvelteComponent);

var AUDIO_EXT = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXT = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXT = /\.(m3u8)($|\?)/i;
var DASH_EXT = /\.(mpd)($|\?)/i;

var is_media_stream = function is_media_stream(src) {
  return IS_CLIENT && is_instance_of(src, window.MediaStream);
};

var is_hls = function is_hls(src) {
  return is_string(src) && HLS_EXT.test(src);
};

var is_dash = function is_dash(src) {
  return is_string(src) && DASH_EXT.test(src);
};

var is_audio = function is_audio(src) {
  return AUDIO_EXT.test(src);
};

var is_video = function is_video(src) {
  return VIDEO_EXT.test(src) || can_play_hls_natively() && is_hls(src);
};

var is_qualities_set = function is_qualities_set(src) {
  return is_array(src) && src.every(function (resource) {
    return is_number(resource.quality);
  });
};

var extract_media_resource = function extract_media_resource(resource) {
  if (is_string(resource) || is_media_stream(resource)) {
    return resource;
  }

  if (is_object(resource)) {
    return resource.src;
  }

  return '';
};

var run_on_every_src = function run_on_every_src(src, cb) {
  return is_array(src) ? src.every(function (resource) {
    return cb(extract_media_resource(resource));
  }) : cb(extract_media_resource(src));
};

var can_play$3 = function can_play$3(src) {
  return is_media_stream(src) || run_on_every_src(src, is_audio) || run_on_every_src(src, is_video);
};
/* src/providers/file/Source.svelte generated by Svelte v3.24.0 */


function get_each_context(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[2] = list[i];
  return child_ctx;
} // (1:0) {#each sources as source}


function create_each_block(ctx) {
  var source;
  var source_src_value;
  var source_type_value;
  var source_quality_value;
  return {
    c: function c() {
      source = element("source");
      if (source.src !== (source_src_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].src :
      /*source*/
      ctx[2] || null)) attr(source, "src", source_src_value);
      attr(source, "type", source_type_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].type : null);
      attr(source, "quality", source_quality_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].quality : null);
    },
    m: function m(target, anchor) {
      insert(target, source, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*sources*/
      1 && source.src !== (source_src_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].src :
      /*source*/
      ctx[2] || null)) {
        attr(source, "src", source_src_value);
      }

      if (dirty &
      /*sources*/
      1 && source_type_value !== (source_type_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].type : null)) {
        attr(source, "type", source_type_value);
      }

      if (dirty &
      /*sources*/
      1 && source_quality_value !== (source_quality_value = is_object(
      /*source*/
      ctx[2]) ?
      /*source*/
      ctx[2].quality : null)) {
        attr(source, "quality", source_quality_value);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(source);
    }
  };
}

function create_fragment$5(ctx) {
  var each_1_anchor;
  var each_value =
  /*sources*/
  ctx[0];
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }

  return {
    c: function c() {
      for (var _i4 = 0; _i4 < each_blocks.length; _i4 += 1) {
        each_blocks[_i4].c();
      }

      each_1_anchor = empty();
    },
    m: function m(target, anchor) {
      for (var _i5 = 0; _i5 < each_blocks.length; _i5 += 1) {
        each_blocks[_i5].m(target, anchor);
      }

      insert(target, each_1_anchor, anchor);
    },
    p: function p(ctx, _ref46) {
      var _ref47 = _slicedToArray(_ref46, 1),
          dirty = _ref47[0];

      if (dirty &
      /*is_object, sources*/
      1) {
        each_value =
        /*sources*/
        ctx[0];

        var _i6;

        for (_i6 = 0; _i6 < each_value.length; _i6 += 1) {
          var child_ctx = get_each_context(ctx, each_value, _i6);

          if (each_blocks[_i6]) {
            each_blocks[_i6].p(child_ctx, dirty);
          } else {
            each_blocks[_i6] = create_each_block(child_ctx);

            each_blocks[_i6].c();

            each_blocks[_i6].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }

        for (; _i6 < each_blocks.length; _i6 += 1) {
          each_blocks[_i6].d(1);
        }

        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching) detach(each_1_anchor);
    }
  };
}

function instance$5($$self, $$props, $$invalidate) {
  var src = $$props.src;
  var sources = [];

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(1, src = $$props.src);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*src*/
    2) {
      if (src) {
        $$invalidate(0, sources = is_array(src) ? src : [src]);
      } else {
        $$invalidate(0, sources = []);
      }
    }
  };

  return [sources, src];
}

var Source = /*#__PURE__*/function (_SvelteComponent6) {
  _inherits(Source, _SvelteComponent6);

  var _super6 = _createSuper(Source);

  function Source(options) {
    var _this6;

    _classCallCheck(this, Source);

    _this6 = _super6.call(this);
    init(_assertThisInitialized(_this6), options, instance$5, create_fragment$5, safe_not_equal, {
      src: 1
    });
    return _this6;
  }

  return Source;
}(SvelteComponent);
/* src/providers/file/Tracks.svelte generated by Svelte v3.24.0 */


function get_each_context$1(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[1] = list[i];
  return child_ctx;
} // (1:0) {#each tracks as track}


function create_each_block$1(ctx) {
  var track;
  var track_default_value;
  var track_src_value;
  var track_srclang_value;
  var track_kind_value;
  var track_label_value;
  return {
    c: function c() {
      track = element("track");
      track.default = track_default_value =
      /*track*/
      ctx[1].default;
      if (track.src !== (track_src_value =
      /*track*/
      ctx[1].src)) attr(track, "src", track_src_value);
      attr(track, "srclang", track_srclang_value =
      /*track*/
      ctx[1].srclang);
      attr(track, "kind", track_kind_value =
      /*track*/
      ctx[1].kind);
      attr(track, "label", track_label_value =
      /*track*/
      ctx[1].label);
    },
    m: function m(target, anchor) {
      insert(target, track, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*tracks*/
      1 && track_default_value !== (track_default_value =
      /*track*/
      ctx[1].default)) {
        track.default = track_default_value;
      }

      if (dirty &
      /*tracks*/
      1 && track.src !== (track_src_value =
      /*track*/
      ctx[1].src)) {
        attr(track, "src", track_src_value);
      }

      if (dirty &
      /*tracks*/
      1 && track_srclang_value !== (track_srclang_value =
      /*track*/
      ctx[1].srclang)) {
        attr(track, "srclang", track_srclang_value);
      }

      if (dirty &
      /*tracks*/
      1 && track_kind_value !== (track_kind_value =
      /*track*/
      ctx[1].kind)) {
        attr(track, "kind", track_kind_value);
      }

      if (dirty &
      /*tracks*/
      1 && track_label_value !== (track_label_value =
      /*track*/
      ctx[1].label)) {
        attr(track, "label", track_label_value);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(track);
    }
  };
}

function create_fragment$6(ctx) {
  var each_1_anchor;
  var each_value =
  /*tracks*/
  ctx[0];
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
  }

  return {
    c: function c() {
      for (var _i7 = 0; _i7 < each_blocks.length; _i7 += 1) {
        each_blocks[_i7].c();
      }

      each_1_anchor = empty();
    },
    m: function m(target, anchor) {
      for (var _i8 = 0; _i8 < each_blocks.length; _i8 += 1) {
        each_blocks[_i8].m(target, anchor);
      }

      insert(target, each_1_anchor, anchor);
    },
    p: function p(ctx, _ref48) {
      var _ref49 = _slicedToArray(_ref48, 1),
          dirty = _ref49[0];

      if (dirty &
      /*tracks*/
      1) {
        each_value =
        /*tracks*/
        ctx[0];

        var _i9;

        for (_i9 = 0; _i9 < each_value.length; _i9 += 1) {
          var child_ctx = get_each_context$1(ctx, each_value, _i9);

          if (each_blocks[_i9]) {
            each_blocks[_i9].p(child_ctx, dirty);
          } else {
            each_blocks[_i9] = create_each_block$1(child_ctx);

            each_blocks[_i9].c();

            each_blocks[_i9].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }

        for (; _i9 < each_blocks.length; _i9 += 1) {
          each_blocks[_i9].d(1);
        }

        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching) detach(each_1_anchor);
    }
  };
}

function instance$6($$self, $$props, $$invalidate) {
  var _$$props$tracks = $$props.tracks,
      tracks = _$$props$tracks === void 0 ? [] : _$$props$tracks;

  $$self.$set = function ($$props) {
    if ("tracks" in $$props) $$invalidate(0, tracks = $$props.tracks);
  };

  return [tracks];
}

var Tracks = /*#__PURE__*/function (_SvelteComponent7) {
  _inherits(Tracks, _SvelteComponent7);

  var _super7 = _createSuper(Tracks);

  function Tracks(options) {
    var _this7;

    _classCallCheck(this, Tracks);

    _this7 = _super7.call(this);
    init(_assertThisInitialized(_this7), options, instance$6, create_fragment$6, safe_not_equal, {
      tracks: 0
    });
    return _this7;
  }

  return Tracks;
}(SvelteComponent);
/* src/providers/file/File.svelte generated by Svelte v3.24.0 */


var document_1 = globals.document;

function add_css$3() {
  var style = element("style");
  style.id = "svelte-183rrqk-style";
  style.textContent = "audio.svelte-183rrqk,video.svelte-183rrqk{border-radius:inherit;vertical-align:middle;width:100%}video.svelte-183rrqk{position:absolute;top:0;left:0;border:0;width:100%;height:100%;-webkit-user-select:none;user-select:none}";
  append(document_1.head, style);
} // (13:25) 


function create_if_block_1$1(ctx) {
  var video_1;
  var source;
  var tracks_1;
  var t;
  var video_1_poster_value;
  var current;
  var mounted;
  var dispose;
  source = new Source({
    props: {
      src:
      /*currentSrc*/
      ctx[6]
    }
  });
  tracks_1 = new Tracks({
    props: {
      tracks:
      /*tracks*/
      ctx[8]
    }
  });
  return {
    c: function c() {
      video_1 = element("video");
      create_component(source.$$.fragment);
      create_component(tracks_1.$$.fragment);
      t = text("\n    Media not supported.");
      video_1.controls =
      /*controls*/
      ctx[4];
      attr(video_1, "crossorigin",
      /*crossorigin*/
      ctx[0]);
      attr(video_1, "poster", video_1_poster_value = !
      /*playbackStarted*/
      ctx[7] ?
      /*poster*/
      ctx[3] : null);
      attr(video_1, "preload", "metadata");
      video_1.playsInline =
      /*playsinline*/
      ctx[5];
      video_1.playsInline =
      /*playsinline*/
      ctx[5];
      attr(video_1, "x5-playsinline",
      /*playsinline*/
      ctx[5]);
      attr(video_1, "webkit-playsinline",
      /*playsinline*/
      ctx[5]);
      attr(video_1, "class", "svelte-183rrqk");
    },
    m: function m(target, anchor) {
      insert(target, video_1, anchor);
      mount_component(source, video_1, null);
      mount_component(tracks_1, video_1, null);
      append(video_1, t);
      /*video_1_binding*/

      ctx[36](video_1);
      current = true;

      if (!mounted) {
        dispose = [listen(video_1, "mozfullscreenchange",
        /*onFullscreenChange*/
        ctx[11]), listen(video_1, "webkitfullscreenchange",
        /*onFullscreenChange*/
        ctx[11]), listen(video_1, "enterpictureinpicture",
        /*onEnterPiP*/
        ctx[12]), listen(video_1, "leavepictureinpicture",
        /*onExitPiP*/
        ctx[13]), listen(video_1, "webkitpresentationmodechanged",
        /*onPresentationModeChange*/
        ctx[14])];
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      var source_changes = {};
      if (dirty[0] &
      /*currentSrc*/
      64) source_changes.src =
      /*currentSrc*/
      ctx[6];
      source.$set(source_changes);
      var tracks_1_changes = {};
      if (dirty[0] &
      /*tracks*/
      256) tracks_1_changes.tracks =
      /*tracks*/
      ctx[8];
      tracks_1.$set(tracks_1_changes);

      if (!current || dirty[0] &
      /*controls*/
      16) {
        video_1.controls =
        /*controls*/
        ctx[4];
      }

      if (!current || dirty[0] &
      /*crossorigin*/
      1) {
        attr(video_1, "crossorigin",
        /*crossorigin*/
        ctx[0]);
      }

      if (!current || dirty[0] &
      /*playbackStarted, poster*/
      136 && video_1_poster_value !== (video_1_poster_value = !
      /*playbackStarted*/
      ctx[7] ?
      /*poster*/
      ctx[3] : null)) {
        attr(video_1, "poster", video_1_poster_value);
      }

      if (!current || dirty[0] &
      /*playsinline*/
      32) {
        video_1.playsInline =
        /*playsinline*/
        ctx[5];
      }

      if (!current || dirty[0] &
      /*playsinline*/
      32) {
        video_1.playsInline =
        /*playsinline*/
        ctx[5];
      }

      if (!current || dirty[0] &
      /*playsinline*/
      32) {
        attr(video_1, "x5-playsinline",
        /*playsinline*/
        ctx[5]);
      }

      if (!current || dirty[0] &
      /*playsinline*/
      32) {
        attr(video_1, "webkit-playsinline",
        /*playsinline*/
        ctx[5]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(source.$$.fragment, local);
      transition_in(tracks_1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(source.$$.fragment, local);
      transition_out(tracks_1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(video_1);
      destroy_component(source);
      destroy_component(tracks_1);
      /*video_1_binding*/

      ctx[36](null);
      mounted = false;
      run_all(dispose);
    }
  };
} // (3:0) {#if shouldUseAudio}


function create_if_block$1(ctx) {
  var audio_1;
  var source;
  var tracks_1;
  var t;
  var current;
  source = new Source({
    props: {
      src:
      /*currentSrc*/
      ctx[6]
    }
  });
  tracks_1 = new Tracks({
    props: {
      tracks:
      /*tracks*/
      ctx[8]
    }
  });
  return {
    c: function c() {
      audio_1 = element("audio");
      create_component(source.$$.fragment);
      create_component(tracks_1.$$.fragment);
      t = text("\n    Media not supported.");
      audio_1.controls =
      /*controls*/
      ctx[4];
      attr(audio_1, "crossorigin",
      /*crossorigin*/
      ctx[0]);
      attr(audio_1, "class", "svelte-183rrqk");
    },
    m: function m(target, anchor) {
      insert(target, audio_1, anchor);
      mount_component(source, audio_1, null);
      mount_component(tracks_1, audio_1, null);
      append(audio_1, t);
      /*audio_1_binding*/

      ctx[35](audio_1);
      current = true;
    },
    p: function p(ctx, dirty) {
      var source_changes = {};
      if (dirty[0] &
      /*currentSrc*/
      64) source_changes.src =
      /*currentSrc*/
      ctx[6];
      source.$set(source_changes);
      var tracks_1_changes = {};
      if (dirty[0] &
      /*tracks*/
      256) tracks_1_changes.tracks =
      /*tracks*/
      ctx[8];
      tracks_1.$set(tracks_1_changes);

      if (!current || dirty[0] &
      /*controls*/
      16) {
        audio_1.controls =
        /*controls*/
        ctx[4];
      }

      if (!current || dirty[0] &
      /*crossorigin*/
      1) {
        attr(audio_1, "crossorigin",
        /*crossorigin*/
        ctx[0]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(source.$$.fragment, local);
      transition_in(tracks_1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(source.$$.fragment, local);
      transition_out(tracks_1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(audio_1);
      destroy_component(source);
      destroy_component(tracks_1);
      /*audio_1_binding*/

      ctx[35](null);
    }
  };
}

function create_fragment$7(ctx) {
  var current_block_type_index;
  var if_block;
  var if_block_anchor;
  var current;
  var if_block_creators = [create_if_block$1, create_if_block_1$1];
  var if_blocks = [];

  function select_block_type(ctx, dirty) {
    if (
    /*shouldUseAudio*/
    ctx[9]) return 0;
    if (
    /*shouldUseVideo*/
    ctx[10]) return 1;
    return -1;
  }

  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }

  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }

      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);

      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, function () {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }

        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];

          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
            if_block.c();
          }

          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }

      if (detaching) detach(if_block_anchor);
    }
  };
}

var Html5 = {};
Html5.PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]; // @see https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1631913-webkitpresentationmode

Html5.WebkitPresentationMode = {
  PIP: "picture-in-picture",
  INLINE: "inline",
  FULLSCREEN: "fullscreen"
}; // @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/track

Html5.TextTrack = {
  Mode: {
    SHOWING: "showing",
    HIDDEN: "hidden"
  },
  Event: {
    CHANGE: "change"
  }
}; // @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events

Html5.Event = {
  LOADED_METADATA: "loadedmetadata",
  PROGRESS: "progress",
  PLAY: "play",
  PAUSE: "pause",
  PLAYING: "playing",
  DURATION_CHANGE: "durationchange",
  RATE_CHANGE: "ratechange",
  SEEKING: "seeking",
  SEEKED: "seeked",
  VOLUME_CHANGE: "volumechange",
  WAITING: "waiting",
  ENDED: "ended",
  ERROR: "error"
};
var canPlay = can_play$3;
var PIP_NOT_SUPPORTED_ERROR_MSG = "PiP not supported."; // --------------------------------------------------------------
// Fullscreen
// --------------------------------------------------------------

var FULLSCREEN_NOT_SUPPORTED_ERROR_MSG$1 = "Fullscreen not supported.";

function instance$7($$self, $$props, $$invalidate) {
  var disposal = [];

  var dispose = function dispose() {
    run_all(disposal);
    disposal = [];
  };

  onDestroy(dispose);
  var hasMounted = false;
  onMount(function () {
    $$invalidate(38, hasMounted = true);
  });
  var dispatch = createEventDispatcher();
  var info = {};
  var audio = null;
  var video = null;
  var prevMedia = null;
  var poster = null;
  var muted = false;
  var controls = null;
  var playsinline = null;
  var aspectRatio = null;
  var currentSrc = null;
  var playbackReady = false;
  var paused = true;
  var videoQuality = null;
  var playbackStarted = false;
  var src = $$props.src;
  var _$$props$crossorigin = $$props.crossorigin,
      crossorigin = _$$props$crossorigin === void 0 ? null : _$$props$crossorigin;
  var _$$props$forceVideo = $$props.forceVideo,
      forceVideo = _$$props$forceVideo === void 0 ? false : _$$props$forceVideo;

  var getEl = function getEl() {
    return media;
  };

  var getMedia = function getMedia() {
    return media;
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    $$invalidate(48, media.currentTime = newTime, media);
  };

  var setMuted = function setMuted(isMuted) {
    $$invalidate(41, muted = isMuted);
  };

  var setPaused = function setPaused(isPaused) {
    isPaused ? media.pause() : media.play().catch(noop);
  };

  var setVolume = function setVolume(newVolume) {
    $$invalidate(48, media.volume = parseFloat(newVolume / 100), media);
  };

  var setPlaybackRate = function setPlaybackRate(newRate) {
    $$invalidate(48, media.playbackRate = newRate, media);
  };

  var setControls = function setControls(isEnabled) {
    $$invalidate(4, controls = isEnabled || null);
  };

  var setPlaysinline = function setPlaysinline(isEnabled) {
    $$invalidate(5, playsinline = isEnabled || null);
  };

  var setAspectRatio = function setAspectRatio(newRatio) {
    $$invalidate(42, aspectRatio = newRatio);
  };

  var setVideoQuality = function setVideoQuality(newVideoQuality) {
    $$invalidate(45, videoQuality = newVideoQuality);
  };

  var setPoster = function setPoster(newPoster) {
    var canReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (poster === newPoster || !is_string(newPoster)) return;
    $$invalidate(3, poster = newPoster || null); // eslint-disable-next-line no-use-before-define

    if (poster && canReload) rebuild();
  };

  var setChromePiP = function setChromePiP(isActive) {
    if (!isActive && document.pictureInPictureElement !== video) Promise.reject();
    isActive ? video.requestPictureInPicture() : document.exitPictureInPicture();
  };

  var setSafariPiP = function setSafariPiP(isActive) {
    var mode = isActive ? Html5.WebkitPresentationMode.PIP : Html5.WebkitPresentationMode.INLINE;

    if (!video.webkitSupportsPresentationMode(mode)) {
      return Promise.reject(PIP_NOT_SUPPORTED_ERROR_MSG);
    }

    return video.webkitSetPresentationMode(mode);
  };

  var supportsPiP = function supportsPiP() {
    return can_use_pip();
  };

  var setPiP = function setPiP(isActive) {
    if (can_use_pip_in_chrome()) {
      return setChromePiP(isActive);
    }

    if (can_use_pip_in_safari()) {
      return setSafariPiP(isActive);
    }

    return Promise.reject(PIP_NOT_SUPPORTED_ERROR_MSG);
  };

  var onFullscreenChange = function onFullscreenChange() {
    $$invalidate(39, info.fullscreen = document.webkitFullscreenElement === video || document.mozFullScreenElement === video, info);
  };

  var setFullscreen = function setFullscreen(isActive) {
    if (!video.webkitSupportsFullscreen) return Promise.reject(FULLSCREEN_NOT_SUPPORTED_ERROR_MSG$1);
    return isActive ? video.webkitEnterFullscreen() : video.webkitExitFullscreen();
  };

  var supportsFullscreen = function supportsFullscreen() {
    return can_fullscreen_video();
  }; // --------------------------------------------------------------
  // Tracks
  // --------------------------------------------------------------


  var tracks = [];
  var currentTrackIndex = -1;

  var setTracks = function setTracks(newTracks) {
    $$invalidate(8, tracks = newTracks || []);
    currentTrackIndex = -1;
  };

  var setTrack = function setTrack(newIndex) {
    var mediaTextTracks = Array.from(media.textTracks);

    if (currentTrackIndex !== -1) {
      mediaTextTracks[currentTrackIndex].mode = Html5.TextTrack.Mode.HIDDEN;
    }

    if (mediaTextTracks.length > 0 && newIndex !== -1) {
      var track = mediaTextTracks[newIndex];
      track.mode = Html5.TextTrack.Mode.SHOWING;
    }

    currentTrackIndex = newIndex;
  };

  var onTracksChange = function onTracksChange() {
    var mediaTextTracks = Array.from(media.textTracks);
    var index = mediaTextTracks.findIndex(function (t) {
      return t.mode === Html5.TextTrack.Mode.SHOWING;
    });
    if (currentTrackIndex !== index) $$invalidate(39, info.currentTrackIndex = index, info);
  }; // --------------------------------------------------------------
  // Media
  // --------------------------------------------------------------


  var timeRaf;

  var cancelTimeUpdates = function cancelTimeUpdates() {
    return window.cancelAnimationFrame(timeRaf);
  };

  onDestroy(cancelTimeUpdates);

  var getTimeUpdates = function getTimeUpdates() {
    $$invalidate(39, info.currentTime = media.currentTime, info);
    timeRaf = raf(getTimeUpdates);
  };

  var listenToMedia = function listenToMedia(event, cb) {
    return disposal.push(listen(media, event, cb));
  };

  var onBuffered = function onBuffered() {
    var _media = media,
        buffered = _media.buffered;
    var _media2 = media,
        duration = _media2.duration;
    var end = buffered.length === 0 ? 0 : buffered.end(buffered.length - 1);
    $$invalidate(39, info.buffered = end > duration ? duration : end, info);
  };

  var setupMediaListeners = function setupMediaListeners() {
    listenToMedia(Html5.Event.LOADED_METADATA, function () {
      $$invalidate(39, info.state = PlayerState.CUED, info);
      $$invalidate(39, info.playbackRates = Html5.PLAYBACK_RATES, info);
      $$invalidate(39, info.mediaType = video ? MediaType.VIDEO : MediaType.AUDIO, info);

      if (srcHasQualities) {
        $$invalidate(39, info.videoQualities = src.map(function (s) {
          return s.quality;
        }), info);
        $$invalidate(39, info.videoQuality = videoQuality, info);
      }

      onBuffered();
      $$invalidate(43, playbackReady = true);
    });
    listenToMedia(Html5.Event.PROGRESS, onBuffered);
    listenToMedia(Html5.Event.PLAY, function () {
      $$invalidate(44, paused = false);
      $$invalidate(39, info.play = true, info);
      $$invalidate(7, playbackStarted = true);
    });
    listenToMedia(Html5.Event.PAUSE, function () {
      $$invalidate(44, paused = true);
      $$invalidate(39, info.state = PlayerState.PAUSED, info);
    });
    listenToMedia(Html5.Event.DURATION_CHANGE, function () {
      $$invalidate(39, info.duration = media.duration, info);
      $$invalidate(39, info.isLive = media.duration === Infinity, info);
    });
    listenToMedia(Html5.Event.PLAYING, function () {
      $$invalidate(39, info.state = PlayerState.PLAYING, info);
    });
    listenToMedia(Html5.Event.RATE_CHANGE, function () {
      $$invalidate(39, info.playbackRate = media.playbackRate, info);
    });
    listenToMedia(Html5.Event.SEEKING, function () {
      $$invalidate(39, info.currentTime = media.currentTime, info);
      $$invalidate(39, info.seeking = true, info);
    });
    listenToMedia(Html5.Event.SEEKED, function () {
      $$invalidate(39, info.seeked = true, info);
    });
    listenToMedia(Html5.Event.VOLUME_CHANGE, function () {
      $$invalidate(39, info.volume = parseInt(media.volume * 100, 10), info);
      $$invalidate(39, info.muted = media.muted, info);
    });
    listenToMedia(Html5.Event.WAITING, function () {
      $$invalidate(39, info.state = PlayerState.BUFFERING, info);
    });
    listenToMedia(Html5.Event.ENDED, function () {
      $$invalidate(39, info.state = PlayerState.ENDED, info);
    });
    listenToMedia(Html5.Event.ERROR, function (e) {
      return dispatch("error", e);
    });
    disposal.push(listen(media.textTracks, Html5.TextTrack.Event.CHANGE, onTracksChange));
  };

  var onEnterPiP = function onEnterPiP() {
    $$invalidate(39, info.pip = true, info);
  };

  var onExitPiP = function onExitPiP() {
    $$invalidate(39, info.pip = false, info);
  };

  var onPresentationModeChange = function onPresentationModeChange() {
    var mode = video.webkitPresentationMode;
    $$invalidate(39, info.pip = mode === Html5.WebkitPresentationMode.PIP, info);
    $$invalidate(39, info.fullscreen = mode === Html5.WebkitPresentationMode.FULLSCREEN, info);
  };

  var load = /*#__PURE__*/function () {
    var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (media) {
                _context10.next = 2;
                break;
              }

              return _context10.abrupt("return");

            case 2:
              _context10.next = 4;
              return tick();

            case 4:
              media.load();

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function load() {
      return _ref50.apply(this, arguments);
    };
  }();

  var rebuild = /*#__PURE__*/function () {
    var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              $$invalidate(39, info.rebuild = true, info);
              $$invalidate(43, playbackReady = false);
              load();

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function rebuild() {
      return _ref51.apply(this, arguments);
    };
  }();

  var loadMediaStream = function loadMediaStream() {
    $$invalidate(6, currentSrc = null);

    try {
      $$invalidate(48, media.srcObject = src, media);
    } catch (e) {
      $$invalidate(48, media.src = window.URL.createObjectURL(src), media);
    }
  };

  var loadNewQuality = /*#__PURE__*/function () {
    var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var didChange;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              didChange = src.some(function (s) {
                return s.quality !== videoQuality;
              });

              if (didChange) {
                _context12.next = 3;
                break;
              }

              return _context12.abrupt("return");

            case 3:
              $$invalidate(6, currentSrc = src.filter(function (s) {
                return s.quality === videoQuality;
              }));
              rebuild();

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function loadNewQuality() {
      return _ref52.apply(this, arguments);
    };
  }();

  var calcInitialQuality = function calcInitialQuality() {
    if (!aspectRatio || videoQuality) return;
    var videoWidth = get_computed_width(video);

    var _aspectRatio$split = aspectRatio.split(":"),
        _aspectRatio$split2 = _slicedToArray(_aspectRatio$split, 2),
        w = _aspectRatio$split2[0],
        h = _aspectRatio$split2[1];

    var minQuality = videoWidth / w * h;
    var qualities = src.map(function (s) {
      return s.quality;
    }); // @see https://stackoverflow.com/a/35000557

    var recommendedQuality = qualities.reduce(function (prev, curr) {
      return Math.abs(curr - minQuality) < Math.abs(prev - minQuality) ? curr : prev;
    });
    var recommendedIndex = qualities.findIndex(function (quality) {
      return quality === recommendedQuality;
    });
    $$invalidate(45, videoQuality = qualities[Math.max(0, recommendedIndex - 1)]);
  };

  var loadNewSrc = function loadNewSrc() {
    $$invalidate(6, currentSrc = src);
    if (currentSrc) load();
  };

  var onSrcChange = function onSrcChange() {
    $$invalidate(43, playbackReady = false);
    $$invalidate(45, videoQuality = null);
    $$invalidate(7, playbackStarted = false);

    if (is_media_stream(src)) {
      loadMediaStream();
    } else {
      loadNewSrc();
    }
  };

  function audio_1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      audio = $$value;
      $$invalidate(1, audio);
    });
  }

  function video_1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      video = $$value;
      $$invalidate(2, video);
    });
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(15, src = $$props.src);
    if ("crossorigin" in $$props) $$invalidate(0, crossorigin = $$props.crossorigin);
    if ("forceVideo" in $$props) $$invalidate(16, forceVideo = $$props.forceVideo);
  };

  var media;
  var srcHasQualities;
  var shouldUseAudio;
  var shouldUseVideo;

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*audio, video*/
    6) {
      $$invalidate(48, media = audio || video);
    }

    if ($$self.$$.dirty[1] &
    /*media, muted*/
    132096) {
      if (media) $$invalidate(48, media.muted = muted, media);
    }

    if ($$self.$$.dirty[0] &
    /*video, src*/
    32772) {
      $$invalidate(49, srcHasQualities = video && is_qualities_set(src));
    }

    if ($$self.$$.dirty[0] &
    /*src*/
    32768 | $$self.$$.dirty[1] &
    /*srcHasQualities, aspectRatio*/
    264192) {
      if (srcHasQualities) calcInitialQuality();
    }

    if ($$self.$$.dirty[0] &
    /*src*/
    32768 | $$self.$$.dirty[1] &
    /*srcHasQualities*/
    262144) {
      if (!srcHasQualities) onSrcChange();
    }

    if ($$self.$$.dirty[1] &
    /*hasMounted, videoQuality*/
    16512) {
      if (hasMounted && is_number(videoQuality)) loadNewQuality();
    }

    if ($$self.$$.dirty[0] &
    /*currentSrc*/
    64 | $$self.$$.dirty[1] &
    /*hasMounted*/
    128) {
      if (hasMounted) tick().then(function () {
        $$invalidate(39, info.currentSrc = currentSrc, info);
      });
    }

    if ($$self.$$.dirty[1] &
    /*playbackReady, paused*/
    12288) {
      playbackReady && !paused ? getTimeUpdates() : cancelTimeUpdates();
    }

    if ($$self.$$.dirty[0] &
    /*src, poster*/
    32776) {
      $$invalidate(9, shouldUseAudio = run_on_every_src(src, is_audio) && !is_string(poster));
    }

    if ($$self.$$.dirty[0] &
    /*forceVideo, src, poster*/
    98312) {
      $$invalidate(10, shouldUseVideo = forceVideo || run_on_every_src(src, is_video) || is_media_stream(src) || is_string(poster));
    }

    if ($$self.$$.dirty[1] &
    /*prevMedia, media*/
    131584) {
      // If media is initialized or changed (audio/video/false).
      if (prevMedia !== media) {
        dispose();
        if (media) setupMediaListeners();
        $$invalidate(40, prevMedia = media);
      }
    }

    if ($$self.$$.dirty[1] &
    /*hasMounted, info*/
    384) {
      if (hasMounted) {
        dispatch("update", info);
        $$invalidate(39, info = {});
      }
    }
  };

  return [crossorigin, audio, video, poster, controls, playsinline, currentSrc, playbackStarted, tracks, shouldUseAudio, shouldUseVideo, onFullscreenChange, onEnterPiP, onExitPiP, onPresentationModeChange, src, forceVideo, getEl, getMedia, setCurrentTime, setMuted, setPaused, setVolume, setPlaybackRate, setControls, setPlaysinline, setAspectRatio, setVideoQuality, setPoster, supportsPiP, setPiP, setFullscreen, supportsFullscreen, setTracks, setTrack, audio_1_binding, video_1_binding];
}

var File = /*#__PURE__*/function (_SvelteComponent8) {
  _inherits(File, _SvelteComponent8);

  var _super8 = _createSuper(File);

  function File(options) {
    var _this8;

    _classCallCheck(this, File);

    _this8 = _super8.call(this);
    if (!document_1.getElementById("svelte-183rrqk-style")) add_css$3();
    init(_assertThisInitialized(_this8), options, instance$7, create_fragment$7, safe_not_equal, {
      src: 15,
      crossorigin: 0,
      forceVideo: 16,
      getEl: 17,
      getMedia: 18,
      setCurrentTime: 19,
      setMuted: 20,
      setPaused: 21,
      setVolume: 22,
      setPlaybackRate: 23,
      setControls: 24,
      setPlaysinline: 25,
      setAspectRatio: 26,
      setVideoQuality: 27,
      setPoster: 28,
      supportsPiP: 29,
      setPiP: 30,
      setFullscreen: 31,
      supportsFullscreen: 32,
      setTracks: 33,
      setTrack: 34
    }, [-1, -1, -1]);
    return _this8;
  }

  _createClass(File, [{
    key: "src",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(src) {
      this.$set({
        src: src
      });
      flush();
    }
  }, {
    key: "crossorigin",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(crossorigin) {
      this.$set({
        crossorigin: crossorigin
      });
      flush();
    }
  }, {
    key: "forceVideo",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(forceVideo) {
      this.$set({
        forceVideo: forceVideo
      });
      flush();
    }
  }, {
    key: "getEl",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "getMedia",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[19];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[20];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[21];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[22];
    }
  }, {
    key: "setPlaybackRate",
    get: function get() {
      return this.$$.ctx[23];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[24];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[25];
    }
  }, {
    key: "setAspectRatio",
    get: function get() {
      return this.$$.ctx[26];
    }
  }, {
    key: "setVideoQuality",
    get: function get() {
      return this.$$.ctx[27];
    }
  }, {
    key: "setPoster",
    get: function get() {
      return this.$$.ctx[28];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[29];
    }
  }, {
    key: "setPiP",
    get: function get() {
      return this.$$.ctx[30];
    }
  }, {
    key: "setFullscreen",
    get: function get() {
      return this.$$.ctx[31];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[32];
    }
  }, {
    key: "setTracks",
    get: function get() {
      return this.$$.ctx[33];
    }
  }, {
    key: "setTrack",
    get: function get() {
      return this.$$.ctx[34];
    }
  }]);

  return File;
}(SvelteComponent);

var File$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': File,
  canPlay: canPlay
});
/* src/providers/YouTube.svelte generated by Svelte v3.24.0 */

function create_fragment$8(ctx) {
  var liteplayer;
  var current;
  var liteplayer_props = {
    src:
    /*src*/
    ctx[0],
    params:
    /*params*/
    ctx[3],
    cookies:
    /*cookies*/
    ctx[1],
    providers: [YouTubeProvider],
    hasWrapper: false
  };
  liteplayer = new LitePlayer({
    props: liteplayer_props
  });
  /*liteplayer_binding*/

  ctx[20](liteplayer);
  liteplayer.$on("error",
  /*error_handler*/
  ctx[21]);
  liteplayer.$on("originchange",
  /*onOriginChange*/
  ctx[5]);
  liteplayer.$on("titlechange",
  /*onTitleChange*/
  ctx[6]);
  liteplayer.$on("rebuild",
  /*onRebuildStart*/
  ctx[4]);
  liteplayer.$on("embedurlchange",
  /*onEmbedURLChange*/
  ctx[7]);
  liteplayer.$on("data",
  /*onData*/
  ctx[8]);
  return {
    c: function c() {
      create_component(liteplayer.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(liteplayer, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var liteplayer_changes = {};
      if (dirty[0] &
      /*src*/
      1) liteplayer_changes.src =
      /*src*/
      ctx[0];
      if (dirty[0] &
      /*params*/
      8) liteplayer_changes.params =
      /*params*/
      ctx[3];
      if (dirty[0] &
      /*cookies*/
      2) liteplayer_changes.cookies =
      /*cookies*/
      ctx[1];
      liteplayer.$set(liteplayer_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(liteplayer.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(liteplayer.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*liteplayer_binding*/
      ctx[20](null);
      destroy_component(liteplayer, detaching);
    }
  };
}

var YT = {}; // @see https://developers.google.com/youtube/iframe_api_reference#Events

YT.Event = {
  READY: "onReady"
}; // @see https://developers.google.com/youtube/iframe_api_reference#Playback_status

YT.State = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
}; // @see https://developers.google.com/youtube/iframe_api_reference#Events

YT.QualityMap = {
  unknown: VideoQuality.UNKNOWN,
  tiny: VideoQuality.XXS,
  small: VideoQuality.XS,
  medium: VideoQuality.S,
  large: VideoQuality.M,
  hd720: VideoQuality.L,
  hd1080: VideoQuality.XL,
  highres: VideoQuality.XXL,
  max: VideoQuality.MAX
}; // @see https://developers.google.com/youtube/iframe_api_reference#Playback_controls

YT.Command = {
  PLAY: "playVideo",
  PAUSE: "pauseVideo",
  SEEK_TO: "seekTo",
  MUTE: "mute",
  UNMUTE: "unMute",
  SET_VOLUME: "setVolume",
  SET_PLAYBACK_RATE: "setPlaybackRate"
};
var canPlay$1 = can_play;

function instance$8($$self, $$props, $$invalidate) {
  var litePlayer;
  var info = {};
  var duration = 0;
  var seeking = false;
  var internalTime = 0;
  var lastTimeUpdate = 0;
  var playbackRate = 1;
  var playerState = -1;
  var params = {
    rel: 0,
    fs: 1,
    iv_load_policy: 3,
    widget_referrer: window.location.href
  };
  var dispatch = createEventDispatcher();

  var send = function send(command, args) {
    return litePlayer && litePlayer.sendCommand(command, args);
  };

  var _$$props$src3 = $$props.src,
      src = _$$props$src3 === void 0 ? null : _$$props$src3;
  var _$$props$cookies2 = $$props.cookies,
      cookies = _$$props$cookies2 === void 0 ? false : _$$props$cookies2;

  var getLitePlayer = function getLitePlayer() {
    return litePlayer;
  };

  var getEl = function getEl() {
    return litePlayer ? litePlayer.getEmbed().getIframe() : null;
  };

  var setMuted = function setMuted(isMuted) {
    isMuted ? send(YT.Command.MUTE) : send(YT.Command.UNMUTE);
  };

  var setVolume = function setVolume(newVolume) {
    send(YT.Command.SET_VOLUME, [newVolume]);
  };

  var setPlaybackRate = function setPlaybackRate(newRate) {
    send(YT.Command.SET_PLAYBACK_RATE, [newRate]);
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    send(YT.Command.SEEK_TO, [newTime]);
  };

  var setPlaysinline = function setPlaysinline(isEnabled) {
    $$invalidate(3, params.playsinline = isEnabled ? 1 : 0, params);
  };

  var setPaused = function setPaused(isPaused) {
    isPaused ? send(YT.Command.PAUSE) : send(YT.Command.PLAY);
  };

  var setControls = function setControls(isEnabled) {
    $$invalidate(3, params.controls = isEnabled ? 1 : 0, params);
    $$invalidate(3, params.disablekb = isEnabled ? 0 : 1, params);
  };

  var supportsPiP = function supportsPiP() {
    return false;
  };

  var supportsFullscreen = function supportsFullscreen() {
    return true;
  };

  var hasMounted = false;
  onMount(function () {
    $$invalidate(22, info.mediaType = MediaType.VIDEO, info);
    $$invalidate(29, hasMounted = true);
  });

  var onRebuildStart = function onRebuildStart() {
    $$invalidate(22, info.rebuild = true, info);
  };

  var onOriginChange = function onOriginChange(e) {
    $$invalidate(22, info.origin = e.detail, info);
  };

  var onTitleChange = function onTitleChange(e) {
    $$invalidate(22, info.title = e.detail, info);
  };

  var onEmbedURLChange = function onEmbedURLChange(e) {
    $$invalidate(22, info.currentSrc = e.detail, info);
    $$invalidate(22, info.mediaId = litePlayer.getMediaId(), info);
  };

  var onStateChange = function onStateChange(state) {
    playerState = state;

    switch (state) {
      case YT.State.ENDED:
        $$invalidate(22, info.state = PlayerState.ENDED, info);
        break;

      case YT.State.PLAYING:
        $$invalidate(22, info.state = PlayerState.PLAYING, info);
        break;

      case YT.State.BUFFERING:
        $$invalidate(22, info.state = PlayerState.BUFFERING, info);
        break;

      case YT.State.PAUSED:
        $$invalidate(22, info.state = PlayerState.PAUSED, info);
        break;

      case YT.State.CUED:
        duration = 0;
        lastTimeUpdate = 0;
        internalTime = 0;
        playbackRate = 1;
        seeking = false;
        $$invalidate(22, info.state = PlayerState.CUED, info);
        break;
    }
  };

  var calcCurrentTime = function calcCurrentTime(time) {
    var currentTime = time;

    if (playerState === YT.State.PLAYING) {
      var elapsedTime = (Date.now() / 1000 - lastTimeUpdate) * playbackRate;
      if (elapsedTime > 0) currentTime += Math.min(elapsedTime, 1);
    }

    return currentTime;
  };

  var onTimeUpdate = function onTimeUpdate(time) {
    var currentTime = calcCurrentTime(time);
    $$invalidate(22, info.currentTime = currentTime, info); // Unfortunately while the player is `paused` `seeking` and `seeked` will fire at the
    // same time, there are no updates at all inbetween -_-.

    if (Math.abs(internalTime - currentTime) > 2) {
      seeking = true;
      $$invalidate(22, info.seeking = true, info);
    }

    internalTime = currentTime;
  };

  var onBuffered = function onBuffered(buffered) {
    $$invalidate(22, info.buffered = buffered, info); // This is the only way to detect `seeked`.

    if (seeking && buffered > internalTime) {
      seeking = false;
      $$invalidate(22, info.seeked = true, info);
    }
  };

  var onInfo = function onInfo(_info) {
    var volume = _info.volume,
        muted = _info.muted,
        rates = _info.availablePlaybackRates,
        quality = _info.playbackQuality,
        rate = _info.playbackRate,
        loadedFraction = _info.videoLoadedFraction,
        qualities = _info.availableQualityLevels,
        currentTime = _info.currentTime,
        newDuration = _info.duration,
        state = _info.playerState,
        currentTimeLastUpdated_ = _info.currentTimeLastUpdated_;
    if (is_number(state)) onStateChange(state);

    if (is_number(newDuration)) {
      duration = parseFloat(newDuration);
      $$invalidate(22, info.duration = duration, info);
    }

    if (rates) $$invalidate(22, info.playbackRates = rates, info);

    if (rate) {
      playbackRate = parseFloat(rate);
      $$invalidate(22, info.playbackRate = playbackRate, info);
    }

    if (is_number(currentTimeLastUpdated_)) lastTimeUpdate = currentTimeLastUpdated_;
    if (is_number(currentTime)) onTimeUpdate(parseFloat(currentTime));
    if (is_number(loadedFraction)) onBuffered(parseFloat(loadedFraction) * duration);
    if (is_number(volume)) $$invalidate(22, info.volume = volume, info);
    if (is_boolean(muted)) $$invalidate(22, info.muted = muted, info);

    if (qualities) {
      var mappedQualities = qualities.map(function (q) {
        return YT.QualityMap[q];
      }).filter(Boolean);
      $$invalidate(22, info.videoQualities = mappedQualities, info);
    }

    if (quality) $$invalidate(22, info.videoQuality = YT.QualityMap[quality], info);
  };

  var onData = function onData(e) {
    var dInfo = e.detail.info;
    if (dInfo) onInfo(dInfo);
  };

  var fetchPoster = function fetchPoster() {
    return fetch_poster(src).then(function (poster) {
      $$invalidate(22, info.poster = poster, info);
    }).catch(function (e) {
      return dispatch("error", e);
    });
  };

  function liteplayer_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      litePlayer = $$value;
      $$invalidate(2, litePlayer);
    });
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(0, src = $$props.src);
    if ("cookies" in $$props) $$invalidate(1, cookies = $$props.cookies);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*hasMounted, src*/
    536870913) {
      if (hasMounted) fetchPoster();
    }

    if ($$self.$$.dirty[0] &
    /*hasMounted, info*/
    541065216) {
      if (hasMounted) {
        dispatch("update", info);
        $$invalidate(22, info = {});
      }
    }
  };

  return [src, cookies, litePlayer, params, onRebuildStart, onOriginChange, onTitleChange, onEmbedURLChange, onData, getLitePlayer, getEl, setMuted, setVolume, setPlaybackRate, setCurrentTime, setPlaysinline, setPaused, setControls, supportsPiP, supportsFullscreen, liteplayer_binding, error_handler];
}

var YouTube = /*#__PURE__*/function (_SvelteComponent9) {
  _inherits(YouTube, _SvelteComponent9);

  var _super9 = _createSuper(YouTube);

  function YouTube(options) {
    var _this9;

    _classCallCheck(this, YouTube);

    _this9 = _super9.call(this);
    init(_assertThisInitialized(_this9), options, instance$8, create_fragment$8, safe_not_equal, {
      src: 0,
      cookies: 1,
      getLitePlayer: 9,
      getEl: 10,
      setMuted: 11,
      setVolume: 12,
      setPlaybackRate: 13,
      setCurrentTime: 14,
      setPlaysinline: 15,
      setPaused: 16,
      setControls: 17,
      supportsPiP: 18,
      supportsFullscreen: 19
    }, [-1, -1]);
    return _this9;
  }

  _createClass(YouTube, [{
    key: "getLitePlayer",
    get: function get() {
      return this.$$.ctx[9];
    }
  }, {
    key: "getEl",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "setPlaybackRate",
    get: function get() {
      return this.$$.ctx[13];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[14];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[15];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[16];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[19];
    }
  }]);

  return YouTube;
}(SvelteComponent);

var YouTube$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': YouTube,
  canPlay: canPlay$1
});
/* src/providers/Vimeo.svelte generated by Svelte v3.24.0 */

function add_css$4() {
  var style = element("style");
  style.id = "svelte-12pareo-style";
  style.textContent = ".wrapper.svelte-12pareo{position:relative;padding-bottom:200%;transform:translateY(-35.95%)}";
  append(document.head, style);
}

function create_fragment$9(ctx) {
  var div;
  var liteplayer;
  var current;
  var liteplayer_props = {
    src:
    /*src*/
    ctx[0],
    params:
    /*params*/
    ctx[3],
    providers: [VimeoProvider],
    hasWrapper: false
  };
  liteplayer = new LitePlayer({
    props: liteplayer_props
  });
  /*liteplayer_binding*/

  ctx[21](liteplayer);
  liteplayer.$on("error",
  /*error_handler*/
  ctx[22]);
  liteplayer.$on("titlechange",
  /*onTitleChange*/
  ctx[5]);
  liteplayer.$on("rebuild",
  /*onReload*/
  ctx[7]);
  liteplayer.$on("rebuild",
  /*onRebuildStart*/
  ctx[4]);
  liteplayer.$on("embedurlchange",
  /*onEmbedURLChange*/
  ctx[6]);
  liteplayer.$on("data",
  /*onData*/
  ctx[8]);
  return {
    c: function c() {
      div = element("div");
      create_component(liteplayer.$$.fragment);
      attr(div, "class", "svelte-12pareo");
      toggle_class(div, "wrapper", !
      /*isControlsEnabled*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(liteplayer, div, null);
      current = true;
    },
    p: function p(ctx, dirty) {
      var liteplayer_changes = {};
      if (dirty[0] &
      /*src*/
      1) liteplayer_changes.src =
      /*src*/
      ctx[0];
      if (dirty[0] &
      /*params*/
      8) liteplayer_changes.params =
      /*params*/
      ctx[3];
      liteplayer.$set(liteplayer_changes);

      if (dirty[0] &
      /*isControlsEnabled*/
      4) {
        toggle_class(div, "wrapper", !
        /*isControlsEnabled*/
        ctx[2]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(liteplayer.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(liteplayer.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      /*liteplayer_binding*/

      ctx[21](null);
      destroy_component(liteplayer);
    }
  };
}

var VM = {}; // @see https://developer.vimeo.com/player/sdk/reference#methods-for-playback-controls

VM.Command = {
  PLAY: "play",
  PAUSE: "pause",
  SET_MUTED: "setMuted",
  SET_VOLUME: "setVolume",
  SET_CURRENT_TIME: "setCurrentTime",
  SET_PLAYBACK_RATE: "setPlaybackRate",
  ADD_EVENT_LISTENER: "addEventListener",
  GET_DURATION: "getDuration",
  GET_CURRENT_TIME: "getCurrentTime",
  GET_TEXT_TRACKS: "getTextTracks",
  ENABLE_TEXT_TRACK: "enableTextTrack",
  DISABLE_TEXT_TRACK: "disableTextTrack"
}; // Some reason event names are different when calling `addEventListener` vs the event name
// that comes through `onData`, hence `VM.Event` and `VM.EVENTS` below.

VM.Event = {
  PLAY: "play",
  PAUSE: "pause",
  READY: "ready",
  LOAD_PROGRESS: "loadProgress",
  BUFFER_START: "bufferstart",
  BUFFER_END: "bufferend",
  LOADED: "loaded",
  FINISH: "finish",
  SEEKING: "seeking",
  SEEKED: "seek",
  CUE_CHANGE: "cuechange",
  FULLSCREEN_CHANGE: "fullscreenchange",
  VOLUME_CHANGE: "volumechange",
  DURATION_CHANGE: "durationchange",
  PLAYBACK_RATE_CHANGE: "playbackratechange",
  TEXT_TRACK_CHANGE: "texttrackchange",
  ERROR: "error"
}; // @see https://developer.vimeo.com/player/sdk/reference#events-for-playback-controls

VM.EVENTS = [VM.Event.PLAY, VM.Event.PAUSE, VM.Event.SEEKING, "seeked", "timeupdate", VM.Event.VOLUME_CHANGE, VM.Event.DURATION_CHANGE, VM.Event.FULLSCREEN_CHANGE, VM.Event.CUE_CHANGE, "progress", VM.Event.ERROR, VM.Event.PLAYBACK_RATE_CHANGE, VM.Event.LOADED, VM.Event.BUFFER_START, VM.Event.BUFFER_END, VM.Event.TEXT_TRACK_CHANGE, "waiting", "ended"];
var canPlay$2 = can_play$1;

function instance$9($$self, $$props, $$invalidate) {
  var litePlayer;
  var info = {};
  var tracks = [];
  var seeking = false;
  var playbackReady = false;
  var internalTime = 0;
  var isControlsEnabled = true;
  var params = {
    // Controlled by Vime.
    autopause: false
  };
  var dispatch = createEventDispatcher();

  var send = function send(command, args) {
    return litePlayer && litePlayer.sendCommand(command, args);
  };

  var _$$props$src4 = $$props.src,
      src = _$$props$src4 === void 0 ? null : _$$props$src4;

  var getLitePlayer = function getLitePlayer() {
    return litePlayer;
  };

  var getEl = function getEl() {
    return litePlayer ? litePlayer.getEmbed().getIframe() : null;
  };

  var setMuted = function setMuted(isMuted) {
    send(VM.Command.SET_MUTED, isMuted);
  };

  var setVolume = function setVolume(newVolume) {
    send(VM.Command.SET_VOLUME, newVolume / 100);
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    send(VM.Command.SET_CURRENT_TIME, newTime);
  };

  var setPlaysinline = function setPlaysinline(isEnabled) {
    $$invalidate(3, params.playsinline = isEnabled, params);
  };

  var setControls = function setControls(isEnabled) {
    $$invalidate(2, isControlsEnabled = isEnabled);
  };

  var setPlaybackRate = function setPlaybackRate(newRate) {
    send(VM.Command.SET_PLAYBACK_RATE, newRate);
  };

  var setPaused = function setPaused(isPaused) {
    isPaused ? send(VM.Command.PAUSE) : send(VM.Command.PLAY);
  };

  var supportsPiP = function supportsPiP() {
    return false;
  };

  var supportsFullscreen = function supportsFullscreen() {
    return true;
  };

  var setTrack = function setTrack(newIndex) {
    if (newIndex === -1) {
      send(VM.Command.DISABLE_TEXT_TRACK);
      return;
    }

    var _tracks$newIndex = tracks[newIndex],
        language = _tracks$newIndex.language,
        kind = _tracks$newIndex.kind;
    send(VM.Command.ENABLE_TEXT_TRACK, {
      language: language,
      kind: kind
    });
  };

  var hasMounted = false;
  onMount(function () {
    $$invalidate(23, info.origin = litePlayer.getOrigin(), info);
    $$invalidate(23, info.mediaType = MediaType.VIDEO, info);
    $$invalidate(28, hasMounted = true);
  });

  var onRebuildStart = function onRebuildStart() {
    $$invalidate(23, info.rebuild = true, info);
  };

  var onTitleChange = function onTitleChange(e) {
    $$invalidate(23, info.title = e.detail, info);
  };

  var onEmbedURLChange = function onEmbedURLChange(e) {
    $$invalidate(23, info.currentSrc = e.detail, info);
    $$invalidate(23, info.mediaId = litePlayer.getMediaId(), info);
  };

  var onReload = function onReload() {
    $$invalidate(26, playbackReady = false);
    $$invalidate(25, seeking = false);
    internalTime = 0;
    tracks = [];
  };

  var onTimeUpdate = function onTimeUpdate(time) {
    $$invalidate(23, info.currentTime = time, info);

    if (Math.abs(internalTime - time) > 1) {
      $$invalidate(25, seeking = true);
      $$invalidate(23, info.seeking = true, info);
    }

    internalTime = time;
  };

  var timeRaf;

  var cancelTimeUpdates = function cancelTimeUpdates() {
    return window.cancelAnimationFrame(timeRaf);
  };

  onDestroy(cancelTimeUpdates);

  var getTimeUpdates = function getTimeUpdates() {
    send(VM.Command.GET_CURRENT_TIME);
    timeRaf = raf(getTimeUpdates);
  };

  var onMethod = function onMethod(method, value) {
    switch (method) {
      case VM.Command.GET_CURRENT_TIME:
        onTimeUpdate(parseFloat(value));
        break;

      case VM.Command.GET_TEXT_TRACKS:
        tracks = value || [];
        $$invalidate(23, info.tracks = tracks.map(function (track) {
          return _objectSpread(_objectSpread({}, track), {}, {
            srclang: track.language
          });
        }), info);
        $$invalidate(23, info.currentTrackIndex = tracks.findIndex(function (t) {
          return t.mode === "showing";
        }), info);
        break;

      case VM.Command.GET_DURATION:
        $$invalidate(23, info.duration = parseFloat(value), info);
        break;
    }
  };

  var onData = function onData(e) {
    var data = e.detail;
    if (!data) return;
    var event = data.event,
        payload = data.data;
    if (data.method) onMethod(data.method, data.value);
    if (!event) return;

    switch (event) {
      case VM.Event.READY:
        VM.EVENTS.forEach(function (vmEvent) {
          return send(VM.Command.ADD_EVENT_LISTENER, vmEvent);
        });
        break;

      case VM.Event.LOADED:
        $$invalidate(23, info.state = PlayerState.CUED, info);
        send(VM.Command.GET_DURATION);
        send(VM.Command.GET_TEXT_TRACKS);
        $$invalidate(26, playbackReady = true);
        break;

      case VM.Event.PLAY:
        $$invalidate(23, info.state = PlayerState.PLAYING, info);
        break;

      case VM.Event.PAUSE:
        $$invalidate(23, info.state = PlayerState.PAUSED, info);
        break;

      case VM.Event.LOAD_PROGRESS:
        $$invalidate(23, info.buffered = parseFloat(payload.seconds), info);
        break;

      case VM.Event.BUFFER_START:
        $$invalidate(23, info.state = PlayerState.BUFFERING, info);
        break;

      case VM.Event.SEEKING:
        $$invalidate(23, info.seeking = true, info);
        break;

      case VM.Event.TEXT_TRACK_CHANGE:
        $$invalidate(23, info.currentTrackIndex = tracks.findIndex(function (t) {
          return t.label === payload.label;
        }), info);
        break;

      case VM.Event.SEEKED:
        $$invalidate(25, seeking = false);
        $$invalidate(23, info.seeked = true, info);
        break;

      case VM.Event.VOLUME_CHANGE:
        $$invalidate(23, info.volume = parseFloat(payload.volume) * 100, info);
        break;

      case VM.Event.DURATION_CHANGE:
        $$invalidate(23, info.duration = parseFloat(payload.duration), info);
        break;

      case VM.Event.PLAYBACK_RATE_CHANGE:
        $$invalidate(23, info.playbackRate = parseFloat(payload.playbackRate), info);
        break;

      case VM.Event.FULLSCREEN_CHANGE:
        $$invalidate(23, info.fullscreen = !!payload.fullscreen, info);
        break;

      case VM.Event.FINISH:
        $$invalidate(23, info.state = PlayerState.ENDED, info);
        break;

      case VM.Event.ERROR:
        dispatch("error", payload);
        break;
    }
  };

  var fetchPoster = function fetchPoster() {
    return fetch_poster$1(src).then(function (poster) {
      $$invalidate(23, info.poster = poster, info);
    }).catch(function (e) {
      return dispatch("error", e);
    });
  };

  function liteplayer_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      litePlayer = $$value;
      $$invalidate(1, litePlayer);
    });
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(0, src = $$props.src);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*hasMounted, src*/
    268435457) {
      if (hasMounted) fetchPoster();
    }

    if ($$self.$$.dirty[0] &
    /*seeking, playbackReady*/
    100663296) {
      !seeking && playbackReady ? getTimeUpdates() : cancelTimeUpdates();
    }

    if ($$self.$$.dirty[0] &
    /*hasMounted, info*/
    276824064) {
      if (hasMounted) {
        dispatch("update", info);
        $$invalidate(23, info = {});
      }
    }
  };

  return [src, litePlayer, isControlsEnabled, params, onRebuildStart, onTitleChange, onEmbedURLChange, onReload, onData, getLitePlayer, getEl, setMuted, setVolume, setCurrentTime, setPlaysinline, setControls, setPlaybackRate, setPaused, supportsPiP, supportsFullscreen, setTrack, liteplayer_binding, error_handler];
}

var Vimeo = /*#__PURE__*/function (_SvelteComponent10) {
  _inherits(Vimeo, _SvelteComponent10);

  var _super10 = _createSuper(Vimeo);

  function Vimeo(options) {
    var _this10;

    _classCallCheck(this, Vimeo);

    _this10 = _super10.call(this);
    if (!document.getElementById("svelte-12pareo-style")) add_css$4();
    init(_assertThisInitialized(_this10), options, instance$9, create_fragment$9, safe_not_equal, {
      src: 0,
      getLitePlayer: 9,
      getEl: 10,
      setMuted: 11,
      setVolume: 12,
      setCurrentTime: 13,
      setPlaysinline: 14,
      setControls: 15,
      setPlaybackRate: 16,
      setPaused: 17,
      supportsPiP: 18,
      supportsFullscreen: 19,
      setTrack: 20
    }, [-1, -1]);
    return _this10;
  }

  _createClass(Vimeo, [{
    key: "getLitePlayer",
    get: function get() {
      return this.$$.ctx[9];
    }
  }, {
    key: "getEl",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[13];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[14];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[15];
    }
  }, {
    key: "setPlaybackRate",
    get: function get() {
      return this.$$.ctx[16];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[19];
    }
  }, {
    key: "setTrack",
    get: function get() {
      return this.$$.ctx[20];
    }
  }]);

  return Vimeo;
}(SvelteComponent);

var Vimeo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Vimeo,
  canPlay: canPlay$2
});
/* src/providers/Dailymotion.svelte generated by Svelte v3.24.0 */

function create_fragment$a(ctx) {
  var liteplayer;
  var current;
  var liteplayer_props = {
    src:
    /*src*/
    ctx[0],
    params:
    /*params*/
    ctx[2],
    providers: [DailymotionProvider],
    hasWrapper: false
  };
  liteplayer = new LitePlayer({
    props: liteplayer_props
  });
  /*liteplayer_binding*/

  ctx[20](liteplayer);
  liteplayer.$on("error",
  /*error_handler*/
  ctx[21]);
  liteplayer.$on("titlechange",
  /*onTitleChange*/
  ctx[4]);
  liteplayer.$on("rebuild",
  /*onRebuildStart*/
  ctx[3]);
  liteplayer.$on("litePlayerurlchange",
  /*onEmbedURLChange*/
  ctx[5]);
  liteplayer.$on("data",
  /*onData*/
  ctx[6]);
  return {
    c: function c() {
      create_component(liteplayer.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(liteplayer, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var liteplayer_changes = {};
      if (dirty[0] &
      /*src*/
      1) liteplayer_changes.src =
      /*src*/
      ctx[0];
      if (dirty[0] &
      /*params*/
      4) liteplayer_changes.params =
      /*params*/
      ctx[2];
      liteplayer.$set(liteplayer_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(liteplayer.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(liteplayer.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*liteplayer_binding*/
      ctx[20](null);
      destroy_component(liteplayer, detaching);
    }
  };
}

var DM = {}; // @see https://developer.dailymotion.com/player/#player-api-events

DM.Event = {
  API_READY: "apiready",
  VIDEO_CHANGE: "videochange",
  VOLUME_CHANGE: "volumechange",
  PLAYBACK_READY: "playback_ready",
  SEEKING: "seeking",
  SEEKED: "seeked",
  WAITING: "waiting",
  PROGRESS: "progress",
  QUALITY_CHANGE: "qualitychange",
  QUALITIES_AVAILABLE: "qualitiesavailable",
  FULLSCREEN_CHANGE: "fullscreenchange",
  DURATION_CHANGE: "durationchange",
  PLAYING: "playing",
  PLAY: "play",
  PAUSE: "pause",
  START: "start",
  AD_START: "ad_start",
  AD_PLAY: "ad_play",
  AD_END: "ad_end",
  TIME_UPDATE: "timeupdate",
  VIDEO_START: "video_start",
  VIDEO_END: "video_end",
  ERROR: "error"
}; // @see https://developer.dailymotion.com/player/#player-api-methods

DM.Command = {
  PLAY: "play",
  PAUSE: "pause",
  SEEK: "seek",
  DURATION: "duration",
  VOLUME: "volume",
  CONTROLS: "controls",
  MUTED: "muted",
  QUALITY: "quality",
  FULLSCREEN: "fullscreen"
};
var canPlay$3 = can_play$2;

function instance$a($$self, $$props, $$invalidate) {
  var mediaId;
  var litePlayer;
  var info = {}; // DM commands don't go through until ads have finished, so we store them and then replay them
  // once the video starts.

  var startTime = null;
  var startVolume = null;
  var startMuted = null;
  var started = false;
  var isAdsPlaying = false;
  var params = {};
  var dispatch = createEventDispatcher();

  var send = function send(command, args) {
    return litePlayer && litePlayer.sendCommand(command, args);
  };

  var _$$props$src5 = $$props.src,
      src = _$$props$src5 === void 0 ? null : _$$props$src5;

  var getLitePlayer = function getLitePlayer() {
    return litePlayer;
  };

  var getEl = function getEl() {
    return litePlayer ? litePlayer.getEmbed().getIframe() : null;
  };

  var setPlaysinline = function setPlaysinline() {};
  /** noop */


  var setVideoQuality = function setVideoQuality(newQuality) {
    send(DM.Command.QUALITY, [newQuality]);
  };

  var setControls = function setControls(isEnabled) {
    send(DM.Command.CONTROLS, [isEnabled]);
  };

  var setFullscreen = function setFullscreen(isActive) {
    send(DM.Command.FULLSCREEN, [isActive]);
  };

  var setPaused = function setPaused(isPaused) {
    isPaused ? send(DM.Command.PAUSE) : send(DM.Command.PLAY);
  };

  var setMuted = function setMuted(isMuted) {
    if (!started) startMuted = isMuted;
    send(DM.Command.MUTED, [isMuted]);
  };

  var setVolume = function setVolume(newVolume) {
    if (!started) startVolume = newVolume;
    send(DM.Command.VOLUME, [newVolume / 100]);
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    if (!started) startTime = newTime;
    send(DM.Command.SEEK, [newTime]);
  };

  var setView = function setView(enabled) {
    $$invalidate(2, params["ui-logo"] = enabled, params);
    $$invalidate(2, params["ui-start-screen-info"] = enabled, params);
  };

  var supportsPiP = function supportsPiP() {
    return false;
  };

  var supportsFullscreen = function supportsFullscreen() {
    return true;
  };

  var hasMounted = false;
  onMount(function () {
    $$invalidate(23, info.origin = litePlayer.getOrigin(), info);
    $$invalidate(23, info.mediaType = MediaType.VIDEO, info);
    $$invalidate(29, hasMounted = true);
  });

  var onRebuildStart = function onRebuildStart() {
    $$invalidate(23, info.rebuild = true, info);
  };

  var onTitleChange = function onTitleChange(e) {
    $$invalidate(23, info.title = e.detail, info);
  };

  var onEmbedURLChange = function onEmbedURLChange(e) {
    mediaId = litePlayer.getMediaId();
    $$invalidate(23, info.currentSrc = e.detail, info);
    $$invalidate(23, info.mediaId = mediaId, info);
  };

  var onData = function onData(e) {
    var data = e.detail;
    var event = data && data.event;
    if (!event) return;

    switch (event) {
      case DM.Event.PLAYBACK_READY:
        startTime = null;
        startVolume = null;
        startMuted = null;
        started = false;
        isAdsPlaying = false;
        $$invalidate(23, info.state = PlayerState.CUED, info);
        break;

      case DM.Event.START:
        $$invalidate(23, info.state = PlayerState.BUFFERING, info);
        break;

      case DM.Event.VIDEO_START:
        if (started) return;

        if (is_number(startTime) && startTime > 0) {
          setCurrentTime(startTime);
          $$invalidate(23, info.seeking = true, info);
        }

        if (is_boolean(startMuted)) setMuted(startMuted);
        if (is_number(startVolume)) setVolume(startVolume);
        started = true;
        break;

      case DM.Event.TIME_UPDATE:
        $$invalidate(23, info.currentTime = parseFloat(data.time), info);
        break;

      case DM.Event.VOLUME_CHANGE:
        $$invalidate(23, info.muted = data.muted === "true", info);
        $$invalidate(23, info.volume = parseFloat(data.volume) * 100, info);
        break;

      case DM.Event.SEEKING:
        $$invalidate(23, info.currentTime = parseFloat(data.time), info);
        $$invalidate(23, info.seeking = true, info);
        break;

      case DM.Event.SEEKED:
        $$invalidate(23, info.currentTime = parseFloat(data.time), info);
        $$invalidate(23, info.seeked = true, info);
        break;

      case DM.Event.WAITING:
        $$invalidate(23, info.state = PlayerState.BUFFERING, info);
        break;

      case DM.Event.PROGRESS:
        $$invalidate(23, info.buffered = parseFloat(data.time), info);
        break;

      case DM.Event.QUALITIES_AVAILABLE:
        $$invalidate(23, info.videoQualities = data.qualities.map(function (quality) {
          return parseInt(quality, 10);
        }), info);
        break;

      case DM.Event.QUALITY_CHANGE:
        $$invalidate(23, info.videoQuality = parseInt(data.quality, 10), info);
        break;

      case DM.Event.AD_START:
        isAdsPlaying = true;
        break;

      case DM.Event.AD_END:
        isAdsPlaying = false;
        break;

      case DM.Event.AD_PLAY:
        send(DM.Command.PLAY);
        break;

      case DM.Event.PLAY:
        $$invalidate(23, info.play = true, info);
        break;

      case DM.Event.PLAYING:
        $$invalidate(23, info.state = PlayerState.PLAYING, info);
        break;

      case DM.Event.PAUSE:
        $$invalidate(23, info.state = PlayerState.PAUSED, info);
        break;

      case DM.Event.DURATION_CHANGE:
        if (!isAdsPlaying) $$invalidate(23, info.duration = parseFloat(data.duration), info);
        break;

      case DM.Event.VIDEO_END:
        $$invalidate(23, info.state = PlayerState.ENDED, info);
        break;

      case DM.Event.FULLSCREEN_CHANGE:
        $$invalidate(23, info.fullscreen = !!data.fullscreen, info);
        break;

      case DM.Event.ERROR:
        dispatch("error", data);
        break;
    }
  };

  var fetchPoster = function fetchPoster() {
    return fetch_poster$2(src).then(function (poster) {
      $$invalidate(23, info.poster = poster, info);
    }).catch(function (e) {
      return dispatch("error", e);
    });
  };

  var fetchVideoDuration = function fetchVideoDuration() {
    return fetch_video_duration(src).then(function (duration) {
      $$invalidate(23, info.duration = duration, info);
    }).catch(function (e) {
      return dispatch("error", e);
    });
  };

  function liteplayer_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      litePlayer = $$value;
      $$invalidate(1, litePlayer);
    });
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("src" in $$props) $$invalidate(0, src = $$props.src);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*hasMounted, src*/
    536870913) {
      if (hasMounted) fetchPoster();
    }

    if ($$self.$$.dirty[0] &
    /*hasMounted, src*/
    536870913) {
      if (hasMounted) fetchVideoDuration();
    }

    if ($$self.$$.dirty[0] &
    /*hasMounted, info*/
    545259520) {
      if (hasMounted) {
        dispatch("update", info);
        $$invalidate(23, info = {});
      }
    }
  };

  return [src, litePlayer, params, onRebuildStart, onTitleChange, onEmbedURLChange, onData, getLitePlayer, getEl, setPlaysinline, setVideoQuality, setControls, setFullscreen, setPaused, setMuted, setVolume, setCurrentTime, setView, supportsPiP, supportsFullscreen, liteplayer_binding, error_handler];
}

var Dailymotion = /*#__PURE__*/function (_SvelteComponent11) {
  _inherits(Dailymotion, _SvelteComponent11);

  var _super11 = _createSuper(Dailymotion);

  function Dailymotion(options) {
    var _this11;

    _classCallCheck(this, Dailymotion);

    _this11 = _super11.call(this);
    init(_assertThisInitialized(_this11), options, instance$a, create_fragment$a, safe_not_equal, {
      src: 0,
      getLitePlayer: 7,
      getEl: 8,
      setPlaysinline: 9,
      setVideoQuality: 10,
      setControls: 11,
      setFullscreen: 12,
      setPaused: 13,
      setMuted: 14,
      setVolume: 15,
      setCurrentTime: 16,
      setView: 17,
      supportsPiP: 18,
      supportsFullscreen: 19
    }, [-1, -1]);
    return _this11;
  }

  _createClass(Dailymotion, [{
    key: "getLitePlayer",
    get: function get() {
      return this.$$.ctx[7];
    }
  }, {
    key: "getEl",
    get: function get() {
      return this.$$.ctx[8];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[9];
    }
  }, {
    key: "setVideoQuality",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "setFullscreen",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[13];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[14];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[15];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[16];
    }
  }, {
    key: "setView",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[19];
    }
  }]);

  return Dailymotion;
}(SvelteComponent);

var Dailymotion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Dailymotion,
  canPlay: canPlay$3
});
/* src/providers/Hls.svelte generated by Svelte v3.24.0 */

function create_fragment$b(ctx) {
  var file;
  var current;
  var file_props = {
    crossorigin:
    /*crossorigin*/
    ctx[1],
    player:
    /*player*/
    ctx[0],
    forceVideo: true
  };
  file = new File({
    props: file_props
  });
  /*file_binding*/

  ctx[26](file);
  file.$on("update",
  /*update_handler*/
  ctx[27]);
  file.$on("error",
  /*error_handler*/
  ctx[28]);
  return {
    c: function c() {
      create_component(file.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(file, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var file_changes = {};
      if (dirty[0] &
      /*crossorigin*/
      2) file_changes.crossorigin =
      /*crossorigin*/
      ctx[1];
      if (dirty[0] &
      /*player*/
      1) file_changes.player =
      /*player*/
      ctx[0];
      file.$set(file_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(file.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(file.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*file_binding*/
      ctx[26](null);
      destroy_component(file, detaching);
    }
  };
}

var canPlay$4 = is_hls;

function instance$b($$self, $$props, $$invalidate) {
  var player = $$props.player;
  var dispatch = createEventDispatcher(); // --------------------------------------------------------------
  // Props
  // --------------------------------------------------------------

  var hls;
  var fileProvider;
  var isHlsAttached = false;
  var _$$props$src6 = $$props.src,
      src = _$$props$src6 === void 0 ? null : _$$props$src6;
  var _$$props$config = $$props.config,
      config = _$$props$config === void 0 ? {} : _$$props$config;
  var _$$props$version = $$props.version,
      version = _$$props$version === void 0 ? "latest" : _$$props$version;
  var _$$props$crossorigin2 = $$props.crossorigin,
      crossorigin = _$$props$crossorigin2 === void 0 ? null : _$$props$crossorigin2;

  var getEl = function getEl() {
    return fileProvider.getEl();
  };

  var getHls = function getHls() {
    return hls;
  };

  var getMedia = function getMedia() {
    return fileProvider.getMedia();
  };

  var getFileProvider = function getFileProvider() {
    return fileProvider;
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    fileProvider.setCurrentTime(newTime);
  };

  var setMuted = function setMuted(isMuted) {
    fileProvider.setMuted(isMuted);
  };

  var setPaused = function setPaused(isPaused) {
    fileProvider.setPaused(isPaused);
  };

  var setVolume = function setVolume(newVolume) {
    fileProvider.setVolume(newVolume);
  };

  var setPlaybackRate = function setPlaybackRate(newRate) {
    fileProvider.setPlaybackRate(newRate);
  };

  var setControls = function setControls(isEnabled) {
    fileProvider.setControls(isEnabled);
  };

  var setPlaysinline = function setPlaysinline(isEnabled) {
    fileProvider.setPlaysinline(isEnabled);
  };

  var setAspectRatio = function setAspectRatio(newRatio) {
    fileProvider.setAspectRatio(newRatio);
  };

  var setTracks = function setTracks(newTracks) {
    fileProvider.setTracks(newTracks);
  };

  var setTrack = function setTrack(newIndex) {
    fileProvider.setTrack(newIndex);
  };

  var setVideoQuality = function setVideoQuality(newVideoQuality) {
    fileProvider.setVideoQuality(newVideoQuality);
  };

  var setPoster = function setPoster(newPoster) {
    return fileProvider.setPoster(newPoster, false);
  };

  var supportsPiP = function supportsPiP() {
    return fileProvider.supportsPiP();
  };

  var setPiP = function setPiP(isActive) {
    return fileProvider.setPiP(isActive);
  };

  var setFullscreen = function setFullscreen(isActive) {
    return fileProvider.setFullscreen(isActive);
  };

  var supportsFullscreen = function supportsFullscreen() {
    return fileProvider.supportsFullscreen();
  }; // --------------------------------------------------------------
  // Events
  // --------------------------------------------------------------


  onMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var url, _Hls;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            dispatch("update", {
              mediaType: MediaType.VIDEO
            });
            _context13.prev = 1;
            url = "https://cdn.jsdelivr.net/npm/hls.js@{V}".replace("{V}", version);
            _context13.next = 5;
            return load_library(url, "Hls");

          case 5:
            _Hls = _context13.sent;

            if (_Hls.isSupported()) {
              _context13.next = 9;
              break;
            }

            dispatch("error", Error("hls.js is not supported"));
            return _context13.abrupt("return");

          case 9:
            hls = new _Hls(config);
            hls.attachMedia(fileProvider.getMedia());
            hls.on(window.Hls.Events.MEDIA_ATTACHED, function () {
              $$invalidate(30, isHlsAttached = true);
            });
            hls.on(window.Hls.Events.ERROR, function (e, data) {
              dispatch("error", {
                e: e,
                data: data
              });
            });
            _context13.next = 18;
            break;

          case 15:
            _context13.prev = 15;
            _context13.t0 = _context13["catch"](1);
            dispatch("error", _context13.t0);

          case 18:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[1, 15]]);
  })));

  var onSrcChange = function onSrcChange(newSrc) {
    hls.loadSource(newSrc);
    dispatch("update", {
      currentSrc: src
    });
  };

  onDestroy(function () {
    if (hls) hls.destroy();
    hls = null;
  });

  function file_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      fileProvider = $$value;
      $$invalidate(2, fileProvider);
    });
  }

  function update_handler(event) {
    bubble($$self, event);
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("player" in $$props) $$invalidate(0, player = $$props.player);
    if ("src" in $$props) $$invalidate(3, src = $$props.src);
    if ("config" in $$props) $$invalidate(4, config = $$props.config);
    if ("version" in $$props) $$invalidate(5, version = $$props.version);
    if ("crossorigin" in $$props) $$invalidate(1, crossorigin = $$props.crossorigin);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*isHlsAttached, src*/
    1073741832) {
      if (isHlsAttached) onSrcChange(src);
    }
  };

  return [player, crossorigin, fileProvider, src, config, version, getEl, getHls, getMedia, getFileProvider, setCurrentTime, setMuted, setPaused, setVolume, setPlaybackRate, setControls, setPlaysinline, setAspectRatio, setTracks, setTrack, setVideoQuality, setPoster, supportsPiP, setPiP, setFullscreen, supportsFullscreen, file_binding, update_handler, error_handler];
}

var Hls = /*#__PURE__*/function (_SvelteComponent12) {
  _inherits(Hls, _SvelteComponent12);

  var _super12 = _createSuper(Hls);

  function Hls(options) {
    var _this12;

    _classCallCheck(this, Hls);

    _this12 = _super12.call(this);
    init(_assertThisInitialized(_this12), options, instance$b, create_fragment$b, safe_not_equal, {
      player: 0,
      src: 3,
      config: 4,
      version: 5,
      crossorigin: 1,
      getEl: 6,
      getHls: 7,
      getMedia: 8,
      getFileProvider: 9,
      setCurrentTime: 10,
      setMuted: 11,
      setPaused: 12,
      setVolume: 13,
      setPlaybackRate: 14,
      setControls: 15,
      setPlaysinline: 16,
      setAspectRatio: 17,
      setTracks: 18,
      setTrack: 19,
      setVideoQuality: 20,
      setPoster: 21,
      supportsPiP: 22,
      setPiP: 23,
      setFullscreen: 24,
      supportsFullscreen: 25
    }, [-1, -1]);
    return _this12;
  }

  _createClass(Hls, [{
    key: "getEl",
    get: function get() {
      return this.$$.ctx[6];
    }
  }, {
    key: "getHls",
    get: function get() {
      return this.$$.ctx[7];
    }
  }, {
    key: "getMedia",
    get: function get() {
      return this.$$.ctx[8];
    }
  }, {
    key: "getFileProvider",
    get: function get() {
      return this.$$.ctx[9];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[13];
    }
  }, {
    key: "setPlaybackRate",
    get: function get() {
      return this.$$.ctx[14];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[15];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[16];
    }
  }, {
    key: "setAspectRatio",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "setTracks",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "setTrack",
    get: function get() {
      return this.$$.ctx[19];
    }
  }, {
    key: "setVideoQuality",
    get: function get() {
      return this.$$.ctx[20];
    }
  }, {
    key: "setPoster",
    get: function get() {
      return this.$$.ctx[21];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[22];
    }
  }, {
    key: "setPiP",
    get: function get() {
      return this.$$.ctx[23];
    }
  }, {
    key: "setFullscreen",
    get: function get() {
      return this.$$.ctx[24];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[25];
    }
  }]);

  return Hls;
}(SvelteComponent);

var Hls$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Hls,
  canPlay: canPlay$4
});
/* src/providers/Dash.svelte generated by Svelte v3.24.0 */

function create_fragment$c(ctx) {
  var file;
  var current;
  var file_props = {
    crossorigin:
    /*crossorigin*/
    ctx[1],
    player:
    /*player*/
    ctx[0],
    forceVideo: true
  };
  file = new File({
    props: file_props
  });
  /*file_binding*/

  ctx[26](file);
  file.$on("update",
  /*update_handler*/
  ctx[27]);
  file.$on("error",
  /*error_handler*/
  ctx[28]);
  return {
    c: function c() {
      create_component(file.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(file, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var file_changes = {};
      if (dirty[0] &
      /*crossorigin*/
      2) file_changes.crossorigin =
      /*crossorigin*/
      ctx[1];
      if (dirty[0] &
      /*player*/
      1) file_changes.player =
      /*player*/
      ctx[0];
      file.$set(file_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(file.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(file.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      /*file_binding*/
      ctx[26](null);
      destroy_component(file, detaching);
    }
  };
}

var canPlay$5 = is_dash;

function instance$c($$self, $$props, $$invalidate) {
  var player = $$props.player;
  var dispatch = createEventDispatcher(); // --------------------------------------------------------------
  // Props
  // --------------------------------------------------------------

  var dash;
  var fileProvider;
  var isDashAttached = false;
  var _$$props$src7 = $$props.src,
      src = _$$props$src7 === void 0 ? null : _$$props$src7;
  var _$$props$config2 = $$props.config,
      config = _$$props$config2 === void 0 ? {} : _$$props$config2;
  var _$$props$version2 = $$props.version,
      version = _$$props$version2 === void 0 ? "latest" : _$$props$version2;
  var _$$props$crossorigin3 = $$props.crossorigin,
      crossorigin = _$$props$crossorigin3 === void 0 ? null : _$$props$crossorigin3;

  var getEl = function getEl() {
    return fileProvider.getEl();
  };

  var getDash = function getDash() {
    return dash;
  };

  var getMedia = function getMedia() {
    return fileProvider.getMedia();
  };

  var getFileProvider = function getFileProvider() {
    return fileProvider;
  };

  var setCurrentTime = function setCurrentTime(newTime) {
    fileProvider.setCurrentTime(newTime);
  };

  var setMuted = function setMuted(isMuted) {
    fileProvider.setMuted(isMuted);
  };

  var setPaused = function setPaused(isPaused) {
    fileProvider.setPaused(isPaused);
  };

  var setVolume = function setVolume(newVolume) {
    fileProvider.setVolume(newVolume);
  };

  var setPlaybackRate = function setPlaybackRate(newRate) {
    fileProvider.setPlaybackRate(newRate);
  };

  var setControls = function setControls(isEnabled) {
    fileProvider.setControls(isEnabled);
  };

  var setPlaysinline = function setPlaysinline(isEnabled) {
    fileProvider.setPlaysinline(isEnabled);
  };

  var setAspectRatio = function setAspectRatio(newRatio) {
    fileProvider.setAspectRatio(newRatio);
  };

  var setTracks = function setTracks(newTracks) {
    fileProvider.setTracks(newTracks);
  };

  var setTrack = function setTrack(newIndex) {
    fileProvider.setTrack(newIndex);
  };

  var setVideoQuality = function setVideoQuality(newVideoQuality) {
    fileProvider.setVideoQuality(newVideoQuality);
  };

  var setPoster = function setPoster(newPoster) {
    return fileProvider.setPoster(newPoster, false);
  };

  var supportsPiP = function supportsPiP() {
    return fileProvider.supportsPiP();
  };

  var setPiP = function setPiP(isActive) {
    return fileProvider.setPiP(isActive);
  };

  var setFullscreen = function setFullscreen(isActive) {
    return fileProvider.setFullscreen(isActive);
  };

  var supportsFullscreen = function supportsFullscreen() {
    return fileProvider.supportsFullscreen();
  }; // --------------------------------------------------------------
  // Events
  // --------------------------------------------------------------


  onMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var url, _Dash;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            dispatch("update", {
              mediaType: MediaType.VIDEO
            });
            _context14.prev = 1;
            url = "https://cdn.jsdelivr.net/npm/dashjs@{V}/dist/dash.all.min.js".replace("{V}", version);
            _context14.next = 5;
            return load_library(url, "dashjs");

          case 5:
            _Dash = _context14.sent;
            dash = _Dash.MediaPlayer(config).create();
            dash.initialize(fileProvider.getMedia(), null, false);
            dash.on(_Dash.MediaPlayer.events.ERROR, function (e) {
              dispatch("error", e);
            });
            $$invalidate(30, isDashAttached = true);
            _context14.next = 15;
            break;

          case 12:
            _context14.prev = 12;
            _context14.t0 = _context14["catch"](1);
            dispatch("error", _context14.t0);

          case 15:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[1, 12]]);
  })));

  var onSrcChange = function onSrcChange(newSrc) {
    dash.attachSource(newSrc);
    dispatch("update", {
      currentSrc: src
    });
  };

  onDestroy(function () {
    if (dash) dash.reset();
    dash = null;
  });

  function file_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      fileProvider = $$value;
      $$invalidate(2, fileProvider);
    });
  }

  function update_handler(event) {
    bubble($$self, event);
  }

  function error_handler(event) {
    bubble($$self, event);
  }

  $$self.$set = function ($$props) {
    if ("player" in $$props) $$invalidate(0, player = $$props.player);
    if ("src" in $$props) $$invalidate(3, src = $$props.src);
    if ("config" in $$props) $$invalidate(4, config = $$props.config);
    if ("version" in $$props) $$invalidate(5, version = $$props.version);
    if ("crossorigin" in $$props) $$invalidate(1, crossorigin = $$props.crossorigin);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*isDashAttached, src*/
    1073741832) {
      if (isDashAttached) onSrcChange(src);
    }
  };

  return [player, crossorigin, fileProvider, src, config, version, getEl, getDash, getMedia, getFileProvider, setCurrentTime, setMuted, setPaused, setVolume, setPlaybackRate, setControls, setPlaysinline, setAspectRatio, setTracks, setTrack, setVideoQuality, setPoster, supportsPiP, setPiP, setFullscreen, supportsFullscreen, file_binding, update_handler, error_handler];
}

var Dash = /*#__PURE__*/function (_SvelteComponent13) {
  _inherits(Dash, _SvelteComponent13);

  var _super13 = _createSuper(Dash);

  function Dash(options) {
    var _this13;

    _classCallCheck(this, Dash);

    _this13 = _super13.call(this);
    init(_assertThisInitialized(_this13), options, instance$c, create_fragment$c, safe_not_equal, {
      player: 0,
      src: 3,
      config: 4,
      version: 5,
      crossorigin: 1,
      getEl: 6,
      getDash: 7,
      getMedia: 8,
      getFileProvider: 9,
      setCurrentTime: 10,
      setMuted: 11,
      setPaused: 12,
      setVolume: 13,
      setPlaybackRate: 14,
      setControls: 15,
      setPlaysinline: 16,
      setAspectRatio: 17,
      setTracks: 18,
      setTrack: 19,
      setVideoQuality: 20,
      setPoster: 21,
      supportsPiP: 22,
      setPiP: 23,
      setFullscreen: 24,
      supportsFullscreen: 25
    }, [-1, -1]);
    return _this13;
  }

  _createClass(Dash, [{
    key: "getEl",
    get: function get() {
      return this.$$.ctx[6];
    }
  }, {
    key: "getDash",
    get: function get() {
      return this.$$.ctx[7];
    }
  }, {
    key: "getMedia",
    get: function get() {
      return this.$$.ctx[8];
    }
  }, {
    key: "getFileProvider",
    get: function get() {
      return this.$$.ctx[9];
    }
  }, {
    key: "setCurrentTime",
    get: function get() {
      return this.$$.ctx[10];
    }
  }, {
    key: "setMuted",
    get: function get() {
      return this.$$.ctx[11];
    }
  }, {
    key: "setPaused",
    get: function get() {
      return this.$$.ctx[12];
    }
  }, {
    key: "setVolume",
    get: function get() {
      return this.$$.ctx[13];
    }
  }, {
    key: "setPlaybackRate",
    get: function get() {
      return this.$$.ctx[14];
    }
  }, {
    key: "setControls",
    get: function get() {
      return this.$$.ctx[15];
    }
  }, {
    key: "setPlaysinline",
    get: function get() {
      return this.$$.ctx[16];
    }
  }, {
    key: "setAspectRatio",
    get: function get() {
      return this.$$.ctx[17];
    }
  }, {
    key: "setTracks",
    get: function get() {
      return this.$$.ctx[18];
    }
  }, {
    key: "setTrack",
    get: function get() {
      return this.$$.ctx[19];
    }
  }, {
    key: "setVideoQuality",
    get: function get() {
      return this.$$.ctx[20];
    }
  }, {
    key: "setPoster",
    get: function get() {
      return this.$$.ctx[21];
    }
  }, {
    key: "supportsPiP",
    get: function get() {
      return this.$$.ctx[22];
    }
  }, {
    key: "setPiP",
    get: function get() {
      return this.$$.ctx[23];
    }
  }, {
    key: "setFullscreen",
    get: function get() {
      return this.$$.ctx[24];
    }
  }, {
    key: "supportsFullscreen",
    get: function get() {
      return this.$$.ctx[25];
    }
  }]);

  return Dash;
}(SvelteComponent);

var Dash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Dash,
  canPlay: canPlay$5
});
export { Dailymotion$1 as DailymotionProvider, Dash$1 as DashProvider, File$1 as FileProvider, Hls$1 as HlsProvider, MediaType, StandardPlayer as Player, PlayerState, VideoQuality, Vimeo$1 as VimeoProvider, YouTube$1 as YouTubeProvider, buildStandardStore };